<template lang="pug" src="./generateImageEditDrawer.pug"></template>

<i18n>
{
    "de": {
        "AI Edit Image": "Bild mit KI bearbeiten",
        "being calculated": "wird berechnet",
        "Edit image": "Bild bearbeiten",
        "Crop": "Zuschneiden",
        "AI edit": "KI-Bearbeitung",
        "Main image": "Hauptbild",
        "List image": "Listenbild",
        "Product page": "Produktseite",
        "Rotate 90°": "90° drehen",
        "Mirror horizontally": "Horizontal spiegeln",
        "Mirror vertically": "Vertikal spiegeln",
        "Aspect ratio": "Seitenverhältnis",
        "Replace image": "Bild ersetzen",
        "Select from library": "Aus Mediathek wählen",
        "The file is too large.": "Die Datei ist zu groß.",
        "Output size": "Ausgabegröße",
        "Fill": "Füllung",
        "Color": "Farbe",
        "Transparent": "Transparent",
        "Auto from edge": "Automatisch vom Rand",
        "Content-aware": "Inhaltsbasiert",
        "Content-aware fill": "Inhaltsbasierte Füllung",
        "Generate AI fill": "Mit KI füllen",
        "Position": "Position",
        "Optionally describe what to add…": "Optional beschreiben, was hinzugefügt werden soll…",
        "Generate fill": "Füllung generieren",
        "AI generates new content to fill the added space.": "Die KI generiert neue Inhalte, um den hinzugefügten Bereich zu füllen.",
        "Drag to crop. Scroll out to make room, then drag the crop past the edge to expand the canvas.": "Zum Zuschneiden ziehen. Zum Vergrößern herauszoomen und den Ausschnitt über den Bildrand hinausziehen, um die Leinwand zu erweitern.",
        "Keep source": "Original beibehalten",
        "Landscape": "Querformat",
        "Portrait": "Hochformat",
        "Keeps the original dimensions.": "Behält die ursprünglichen Abmessungen bei.",
        "The AI renders at this aspect ratio.": "Die KI rendert in diesem Seitenverhältnis.",
        "Reset crop": "Zuschnitt zurücksetzen",
        "File": "Datei",
        "Name": "Name",
        "Dimensions": "Abmessungen",
        "Free": "Frei",
        "Original": "Original",
        "Custom": "Benutzerdefiniert",
        "Variants": "Varianten",
        "Versions": "Versionen",
        "Delete version": "Version löschen",
        "Delete this version and any versions derived from it? The original stays untouched.": "Diese Version und alle davon abgeleiteten Versionen löschen? Das Original bleibt unangetastet.",
        "Drag on the image to set the crop. It updates this version in place.": "Ziehe am Bild, um den Ausschnitt zu setzen. Er aktualisiert diese Version direkt.",
        "You can close this. The image will appear in the media library when it is ready.": "Du kannst dies schließen. Das Bild erscheint in der Medienbibliothek, sobald es fertig ist.",
        "Apply crop": "Zuschnitt anwenden",
        "Close": "Schließen",
        "Save": "Speichern",
        "Delete": "Löschen",
        "Delete variant": "Variante löschen",
        "Don't keep asking": "Nicht mehr fragen",
        "Drag to choose the crop. It is applied as a new, non-destructive variant.": "Ziehe den Ausschnitt. Er wird als neue, zerstörungsfreie Variante angewendet.",
        "Delete this variant and any variants derived from it? The original stays untouched.": "Diese Variante und alle davon abgeleiteten Varianten löschen? Das Original bleibt unangetastet.",
        "kind.original": "Original",
        "kind.crop": "Zuschnitt",
        "kind.ai-edit": "KI-Bearbeitung",
        "kind.current": "Aktuelle Bearbeitung",
        "Current Edit": "Aktuelle Bearbeitung",
        "Original (source)": "Original",
        "Source image": "Quellbild",
        "Suggestions": "Vorschläge",
        "Custom prompt": "Eigener Prompt",
        "Error": "Fehler",
        "Generation failed": "Generierung fehlgeschlagen",
        "More suggestions": "Weitere Vorschläge",
        "Templates": "Vorlagen",
        "Load more": "Mehr laden",
        "This template sends reference images, only models with multi-image input are selectable.": "Diese Vorlage sendet Referenzbilder, nur Modelle mit Mehrbild-Eingabe sind wählbar.",
        "Image edit": "Bildbearbeitung",
        "maximum": "maximal",
        "Billed are the actual generation costs, at most this amount.": "Abgerechnet werden die tatsächlichen Generierungskosten, höchstens dieser Betrag.",
        "AI preparation": "KI-Aufbereitung",
        "this edit": "diese Bearbeitung",
        "Actual cost of the AI suggestions and prompt prepared for this edit.": "Tatsächliche Kosten der KI-Vorschläge und des Prompts für diese Bearbeitung.",
        "Prompt": "Prompt",
        "Rephrase": "Neu formulieren",
        "Phrasing…": "Wird formuliert…",
        "Review and edit this prompt before generating.": "Prüfe und bearbeite diesen Prompt vor dem Generieren.",
        "Describe the edit you want to make…": "Beschreibe die gewünschte Bearbeitung…",
        "Model": "Modell",
        "Estimated cost": "Geschätzte Kosten",
        "Generate": "Generieren",
        "Cancel": "Abbrechen",
        "Loading suggestions": "Vorschläge werden geladen",
        "You can close this drawer. The image will appear in the media library when it is ready.": "Du kannst diesen Bereich schließen. Das Bild erscheint in der Medienbibliothek, sobald es fertig ist.",
        "unit.images": "Bild | Bilder",
        "phase.submitting": "Wird übermittelt…",
        "phase.queued": "In Warteschlange…",
        "phase.generating": "Wird generiert…",
        "phase.downloading": "Wird heruntergeladen…",
        "phase.storing": "Wird gespeichert…",
        "phase.concatenating": "Wird zusammengefügt…",
        "phase.starting": "Wird gestartet…"
    },
    "en": {
        "AI Edit Image": "AI Edit Image",
        "kind.original": "Original",
        "kind.crop": "Crop",
        "kind.ai-edit": "AI edit",
        "kind.current": "Current Edit",
        "Source image": "Source image",
        "unit.images": "image | images",
        "phase.submitting": "Submitting…",
        "phase.queued": "Queued…",
        "phase.generating": "Generating…",
        "phase.downloading": "Downloading…",
        "phase.storing": "Saving…",
        "phase.concatenating": "Stitching…",
        "phase.starting": "Starting…"
    }
}
</i18n>

<script>
import _ from 'lodash';
import uniqid from 'uniqid';
import EditorCanvas from '@/extensions/generative-media/views/Drawers/EditorCanvas';
import AltTextField from '@/extensions/generative-media/components/AltTextField';
import AiDisclosureField from '@/extensions/generative-media/components/AiDisclosureField';
import ImageLibraryDialog from '@/components/Page/Sections/Partials/ImageLibraryDialog';
import { useAuthStore, useSetupStore } from '@/stores';
import api from '@/extensions/generative-media/store/api/generativeMedia';
import { productImageOptions, singleImageOption, originalImageUrl, proxiedFileUrl } from '@/extensions/generative-media/imageThumbnail';
import { getProcessingFromCropData, getImageCrop, toOutputFrame, toSourceFrame, aspectRatioPresets, cropExceedsImage, getFillParams, getFillStateFromParams } from '@/extensions/generative-media/cropMath';
import { getFitStringFromProcessObject, ensureFreshToken } from '@/helpers';
import { moneyFormat } from '@/filters';
import AiEditControls from '@/extensions/generative-media/components/AiEditControls';
import Echo from '@/echo';

// Longest-edge pixel cap for the version-list preview thumbnails. They render at
// ~48px, so anything beyond this is wasted work — and because the "Current Edit"
// preview is an on-the-fly (ephemeral) crop render of the full-resolution source,
// requesting it at full output size made each tiny thumbnail decode+encode a
// multi-megabyte image on the backend, which (under rapid crop/zoom changes) could
// saturate the API fpm pool. Capping w/h here keeps the same crop at a cheap size.
const THUMB_MAX_PX = 200;

export default {
    name: 'GenerateImageEditDrawer',
    components: {
        AiEditControls,
        EditorCanvas,
        AltTextField,
        AiDisclosureField,
        ImageLibraryDialog,
    },
    props: {
        visible: { type: Boolean, default: false },
        // Product/article context (media tile). Optional: when absent the drawer runs
        // in single-image mode for business-card / CMS-content images. `subjectType`
        // decides whether `product` is a product or an article (same flow) — driving
        // product_id vs article_id and the per-subject progress channel.
        product: { type: Object, default: null },
        subjectType: { type: String, default: 'product' },
        // The image this drawer was opened for (clicked "Edit" on a media tile).
        // String too: a freshly-uploaded, not-yet-persisted image has a `new:…` id.
        sourceImageId: { type: [Number, String], default: null },
        // Single-image mode: the image object (with its `variants`) to edit directly,
        // used when there is no product (business cards, CMS content).
        image: { type: Object, default: null },
        // Inline mode renders the editor body without the drawer shell, so a host
        // (CMS content editor) can embed it directly — no nested drawer.
        inline: { type: Boolean, default: false },
        // Mutable = the image has a persisted id the variant mutations can target.
        // Unsaved images (client 'new:' ids) are not mutable → AI + variant stack hide.
        mutable: { type: Boolean, default: true },
        // When the caller enforces a fixed crop ratio (e.g. business-card logo = 1:1),
        // lock the cropper to it and hide the aspect-ratio presets.
        fixedAspectRatio: { type: Number, default: null },
        // Open on the crop tool even before a crop is saved, for hosts that open the
        // editor in order to crop (the WhatsApp banner). Without it a locked ratio only
        // shows the passive overlay, where the wheel scrolls the page instead of zooming out.
        startInCrop: { type: Boolean, default: false },
        // A resolved URL to the current pixels, supplied by the host when the image
        // has no DB `source` yet (a freshly-uploaded file living only in the uploads
        // table). Lets the canvas render before the image is persisted.
        previewUrl: { type: String, default: null },
        // Content / business-card crops are non-destructive focal-point crops stored
        // in the image's `settings.processing` and applied on page save — no server
        // mutation, works on fresh uploads. The editor emits `crop` instead of calling
        // ApplyImageCrop, and the host's footer is the single save action.
        deferredCrop: { type: Boolean, default: false },
        // Upload context for the editor's own Replace/Upload control: the upload
        // endpoint + the `context[type]` (and optional morph model/id for business
        // cards). When absent the Upload button is hidden (host owns upload).
        uploadContext: { type: Object, default: null },
        // Show the "Select from library" action + embed the media-library dialog.
        allowLibrary: { type: Boolean, default: true },
        // Show product image-role toggles (main/list/detail) overlaid on the canvas.
        // The host handles persistence via the `toggle-role` event. Off by default so
        // it only appears where wired (mobile catalog), not in the desktop product form.
        showRoleToggles: { type: Boolean, default: false },
    },
    data() {
        return {
            loadingModels: false,
            loadingSuggestions: false,
            loadingMore: false,
            generating: false,
            libraryDialogVisible: false,
            // A pending image replacement (upload/library swap) — a DRAFT committed to
            // the host only on Save/OK, so Cancel leaves the original media untouched.
            replacementPending: false,
            replacementPreviousId: null,
            models: [],
            outpaintModels: [], // image-outpaint model(s) — for the AI fill cost estimate
            suggestions: [],
            // Prompt templates (cms-wide, curated in AI Tools). 'templates' is the
            // default AI source when any exist; suggestions stay untouched behind
            // the second toggle pane.
            templates: [],
            templatesTotal: 0,
            loadingTemplates: false,
            loadingMoreTemplates: false,
            aiSource: 'suggestions',
            selectedTemplateId: null,
            // Refreshed right before each upload (see updateUploadHeaders) — mirrors the
            // product/business-card upload reference so the editor's Replace/Upload sends
            // a FRESH, valid token (a stale JWT was the in-editor upload failure).
            selectedImageId: null,
            selectedModelKey: null,
            selectedOptionKey: null,
            selectedOptionDescription: null,
            // AI output dimensions: keep the source size by default ("source") so the
            // model stops reframing/squaring the result; the user can force a ratio.
            outputAspect: 'source',
            outputOrientation: 'landscape',
            // Cost levers. Null = use the CMS default, then the model default (see
            // GenerativeMediaService::resolveLeverValue on the backend).
            outputQuality: null,
            outputResolutionCap: null,
            phrasedPrompt: '',
            phrasing: false,
            orchestrationCost: 0,
            orchestrationBaseline: 0,
            generationProgress: null,
            generationPhase: null,
            channels: [],
            // Unified Edit drawer: crop + AI + layer stack. No tool active by default —
            // the canvas just shows the image until the user picks a tool.
            mode: null,
            // The locked aspect ratio in the DISPLAYED (rotated) frame the user sees.
            // NaN = free. The source-frame ratio handed to the canvas is derived from this
            // + the active rotation (computed `aspectRatio`), so a 90/270 rotation never
            // flips the visible lock.
            displayedAspect: NaN,
            ratioLandscape: true, // orientation of the active ratio (toggled on re-click)
            activeRatioKey: 'free',
            customRatioInput: '', // e.g. "16:9" when the Custom preset is active
            applyingCrop: false,
            saving: false,
            activeDirty: false, // a version switch is pending commit (product Save)
            cropDirty: false,   // crop / transform changed and is pending commit (product mode)
            deferredDirty: false, // deferred (content / business-card) crop/flip applied — enables Save
            aiDisclosureDirty: false, // Art. 50(4) toggle / display mode changed — enables Save
            // The editor flipped the disclosure switch by hand in this session. A
            // version switch then stops deriving the boolean, so it cannot silently
            // undo a declaration the editor just made.
            aiDiscloseTouched: false,
            // Transform tools (rotate / mirror): the EditorCanvas applies them to the
            // whole stage; the crop (in source pixels) tracks the motive on its own.
            transformRotate: 0,
            transformFlipH: false,
            transformFlipV: false,
            // The crop rectangle in SOURCE pixels { x, y, width, height } (null = none).
            cropRect: null,
            // Canvas-expand fill: applied when the crop frame extends beyond the image.
            // The geometry IS the crop rect (out of bounds); these only pick how the
            // revealed area is filled.
            fillMode: 'solid',        // 'solid' | 'transparent' | 'ai'
            fillColorHex: '#ffffff',  // el-color-picker model (solid fill)
            fillPrompt: '',           // optional AI fill guidance (fill-gen-prompt)
            // The loaded canvas image's TRUE intrinsic size { url, width, height } — the
            // authoritative source dims for the cropper (see naturalCropSize).
            measuredNatural: null,
            // The focal params (+ flags) pending commit, derived from cropRect on change.
            pendingCropParams: null,
            // Debounced mirror of pendingCropParams used ONLY to build the version
            // preview thumbnails, so a rapid crop/zoom drag refetches the preview once
            // it settles instead of once per tick (see watch.pendingCropParams).
            thumbCropParams: null,
            localImage: null, // the source image with its live variant stack
            canvasAvailableWidth: 0, // measured pane width (drives the contain math)
            deleteDialog: { visibility: false, loading: false, layer: null, remember: false },
        };
    },
    computed: {
        uploadHeaders() {
            return {
                authorization: `Bearer ${useAuthStore().token}`,
                accept: 'application/json',
            };
        },
        cmsId() {
            const id = _.get(useSetupStore().activeCms, 'id');
            return id ? parseInt(id, 10) : null;
        },
        // The AI edit generates from whatever is currently active (the base for the next
        // edit, which may already be a previous AI version with different dimensions than
        // the original) — falls back to the image itself when no version is active yet.
        sourceLongEdge() {
            const width = _.get(this.activeLayer, 'width') || _.get(this.localImage, 'width');
            const height = _.get(this.activeLayer, 'height') || _.get(this.localImage, 'height');
            return width && height ? Math.max(width, height) : null;
        },
        // Shop-wide AI disclosure display mode, shown so the per-image "inherit"
        // option names what it would inherit. Falls back to the visible mode, which
        // is also the backend default.
        shopAiLabelDisplay() {
            return _.get(useSetupStore().activeCms, 'generativeMediaSettings.ai_label_display') || 'permanent';
        },
        // Null in single-image (no-product) mode. Holds the subject id (product OR article).
        productId() {
            const id = _.get(this.product, 'id');
            return id ? parseInt(id, 10) : null;
        },
        // The subject id split into the right mutation slot (product_id vs article_id).
        subjectProductId() {
            return this.subjectType === 'article' ? null : this.productId;
        },
        subjectArticleId() {
            return this.subjectType === 'article' ? this.productId : null;
        },
        // Drawer mode follows `visible`; inline mode is always active.
        active() {
            return this.inline ? true : this.visible;
        },
        aiEnabled() {
            const extensions = _.get(useSetupStore().activeCms, 'extensions', []) || [];
            return !!extensions.find(extension => extension.key === 'ai-image-edit');
        },
        aspectRatioPresets() {
            return aspectRatioPresets;
        },
        // "OK" when the commit only drafts/defers locally (fresh upload — the host's
        // product/page save persists it); "Save" when it fires a server mutation now.
        commitLabel() {
            // "OK" when the editor only DRAFTS/DEFERS (fresh upload, or deferred-crop
            // content/business-card images — the crop is handed to the host, no server
            // mutation here); "Save" when it commits a mutation (product variant) now.
            return (this.isFreshUpload || this.deferredCrop) ? this.$t('OK') : this.$t('Save');
        },
        // Whether the commit button (OK / Save) is clickable.
        //
        // In DEFERRED mode (CMS content / business card) OK persists nothing itself — it
        // hands the draft to the host and closes; the host's own save writes it. The drawer
        // additionally hosts the content's own fields (caption/link/…) and the alt-text
        // field, and NONE of the crop/version flags track those. Gating OK on them left
        // "open an existing image, type a caption → OK stays greyed out, nothing can be
        // confirmed". So in deferred mode OK is always available.
        //
        // In PRODUCT mode the button fires server mutations, so it stays gated on real
        // drafts — including a pending image replacement, which commits only here.
        // The Art. 50 panel lives in this drawer too, and changing only the disclosure
        // toggle or its display mode is a real, saveable change — without
        // `aiDisclosureDirty` here it looked like "nothing happened" and OK stayed grey,
        // the same trap alt text and captions hit before.
        canCommit() {
            if (this.deferredCrop || this.isFreshUpload) return true;
            return this.activeDirty || this.cropDirty || this.replacementPending || this.aiDisclosureDirty;
        },
        // Did the user actually touch a crop / transform tool this session? Drives the
        // re-capture on save — without it, merely confirming an untouched image would
        // stamp a full-frame crop into its settings.processing.
        cropTouched() {
            return this.cropDirty
                || this.deferredDirty
                || !!this.transformRotate
                || this.transformFlipH
                || this.transformFlipV;
        },
        // Auth + context for the editor's own Replace/Upload control.
        uploadData() {
            const context = this.uploadContext || {};
            const data = { 'context[type]': context.type };
            if (context.model) data['context[model]'] = context.model;
            if (context.id != null) data['context[id]'] = context.id;
            return data;
        },
        // AI output-size choices. "source" keeps the original dimensions (default);
        // the ratios are the set every image-edit model can express natively.
        // A freshly-uploaded image is only an `uploads`-table record (flagged
        // `upload`) with no DB `source`/`variants` yet. AI sources from the upload
        // file and crop is deferred — no Image is persisted until the page is saved.
        isFreshUpload() {
            // CMS content uploads flag `upload` on the image itself; product uploads
            // nest it as `source.upload` with a client `new:` image id. Either means
            // there's no persisted Image yet → edit the uploads-table file directly.
            return !!_.get(this.localImage, 'upload')
                || !!_.get(this.localImage, 'source.upload')
                || String(_.get(this.localImage, 'id', '')).startsWith('new:')
                || !_.get(this.localImage, 'source');
        },
        // The uploads-table id to AI-edit for a fresh upload (product: source.id;
        // CMS content: the image id itself).
        freshUploadId() {
            if (_.get(this.localImage, 'source.upload')) {
                return parseInt(_.get(this.localImage, 'source.id'), 10) || null;
            }
            if (_.get(this.localImage, 'upload')) {
                return parseInt(_.get(this.localImage, 'id'), 10) || null;
            }
            return null;
        },
        // A library pick: an existing File chosen from the media library, not yet
        // attached as an Image (its working id is a `new:file-library:` token, its
        // `source` is the real File with NO `upload` flag).
        isLibrarySelection() {
            const source = _.get(this.localImage, 'source');
            const id = _.get(this.localImage, 'id');
            return !!source && !source.upload
                && typeof id === 'string' && id.indexOf('new:file-library:') === 0;
        },
        // The existing File id behind a library pick (the backend suggest/generate File path).
        librarySourceFileId() {
            if (!this.isLibrarySelection) return null;
            return parseInt(_.get(this.localImage, 'source.id'), 10) || null;
        },
        // The File backing the currently-active VERSION (the layer selected in the stack).
        // The AI edit AND the suggestions operate on THIS file's pixels, so switching
        // versions changes what the AI sees. Null for the synthesised Original of an image
        // that has no variants yet (the backend then falls back to the source).
        activeBaseFileId() {
            const layer = this.activeLayer;
            if (!layer) return null;
            // The Original layer edits the TRUE uncropped source (its `cropBase`), not a
            // crop the server folded into it — so "keep size" reproduces the real source
            // dimensions and any folded crop stays untouched as its own derivative. Other
            // layers edit their own (`file`) pixels.
            const file = layer.id === 'original'
                ? (_.get(layer, 'cropBase') || _.get(layer, 'file'))
                : _.get(layer, 'file');
            return parseInt(_.get(file, 'id'), 10) || null;
        },
        // The REAL backend subject for suggestions/generation. After a replace,
        // `selectedImageId` is a synthetic client `new:` token — never a backend id — so
        // the suggestion calls must resolve the actual id by source kind:
        //  • persisted image → its (numeric) image id,
        //  • genuine upload  → the uploads-table id (freshUploadId),
        //  • library pick    → the existing File id (the backend resolves its URL).
        // Returns { imageIds, uploadIds, fileIds } or null when there's no subject.
        suggestionSubjectIds() {
            if (this.librarySourceFileId) {
                return { imageIds: null, uploadIds: null, fileIds: [this.librarySourceFileId] };
            }
            if (!this.isFreshUpload) {
                // Persisted image: suggest on the SELECTED version's pixels (its File) so
                // switching versions re-evaluates suggestions for what's actually shown.
                // Falls back to the image id for the synthesised Original (no File id).
                if (this.activeBaseFileId) {
                    return { imageIds: null, uploadIds: null, fileIds: [this.activeBaseFileId] };
                }
                const imageId = parseInt(this.selectedImageId, 10);
                return imageId ? { imageIds: [imageId], uploadIds: null, fileIds: null } : null;
            }
            if (this.freshUploadId) {
                return { imageIds: null, uploadIds: [this.freshUploadId], fileIds: null };
            }
            return null;
        },
        layers() {
            const variants = _.get(this.localImage, 'variants', []) || [];
            if (variants.length) return variants;
            // No server variants (fresh upload, or a persisted image before its first
            // edit): synthesise a single Original layer so the version stack + active
            // state render consistently.
            if (!this.localImage) return [];
            // Prefer the token-authenticated app route (originalImageUrl) over the raw
            // `source.url`: on DigitalOcean the CDN url ignores the object's visibility,
            // so a private file (restricted-page content image) renders AccessDenied.
            // Skip `previewUrl` while replacing: it's the HOST's url for the OLD image, so
            // it would make the synthesised Original (and thus the canvas) show the stale
            // image instead of the just-uploaded/picked one.
            const url = originalImageUrl(this.localImage)
                || _.get(this.localImage, 'source.url')
                || (this.replacementPending ? null : this.previewUrl);
            if (!url) return [];
            return [{
                id: 'original',
                kind: 'original',
                label: 'Original',
                active: true,
                file: { url },
                cropBase: { url },
                base: null,
                width: _.get(this.localImage, 'width'),
                height: _.get(this.localImage, 'height'),
            }];
        },
        // Newest layer on top, the Original at the bottom.
        // Dimensions + file metadata shown above the tool options. Output (crop) size is
        // the crop rect, swapped for a 90/270 rotation; source size + format/size come
        // from the source File.
        imageMeta() {
            const { width, height } = this.naturalCropSize;
            if (!width || !height) return null;
            let outWidth = this.cropRect ? this.cropRect.width : width;
            let outHeight = this.cropRect ? this.cropRect.height : height;
            if (this.transformRotated) {
                const swap = outWidth;
                outWidth = outHeight;
                outHeight = swap;
            }
            const source = _.get(this.localImage, 'source') || {};
            const mime = source.mime || _.get(this.localImage, 'mime') || '';
            const format = mime ? mime.split('/').pop().toUpperCase() : null;
            const size = source.size || _.get(this.localImage, 'size');
            const sourceWidth = Math.round(width);
            const sourceHeight = Math.round(height);
            const croppedWidth = Math.round(outWidth);
            const croppedHeight = Math.round(outHeight);

            return {
                name: source.name || _.get(this.localImage, 'name') || null,
                sourceWidth,
                sourceHeight,
                outWidth: croppedWidth,
                outHeight: croppedHeight,
                // Original vs Crop is only worth two rows when they actually differ —
                // otherwise it is the same number printed twice under two labels.
                //
                // Compared with a tolerance, because an uncropped image can still come
                // out a few pixels short: fal rounds an AI edit's output to a multiple
                // of 16 (1950x2600 -> 1952x2608), and fitting that variant's ratio back
                // into the source rounds to 1946x2600 — 0.2% off, and not a crop anyone
                // made. A deliberate crop is orders of magnitude larger than this.
                cropped: Math.abs(croppedWidth - sourceWidth) > sourceWidth * 0.005
                    || Math.abs(croppedHeight - sourceHeight) > sourceHeight * 0.005,
                format,
                size: size ? this.formatBytes(size) : null,
            };
        },
        // True when the user made UNSAVED crop/rotate/flip edits in THIS session.
        // Drives the synthetic "Current Edit" row — which must NOT appear from merely
        // switching versions: a version's restored saved crop also yields a non-full
        // rect, and a rect seeded before the real pixels were measured compares against
        // the wrong dimensions (that spawned a phantom "new variant on top" + a crop
        // overlay nobody made). The dirty flags track exactly "edited this session".
        hasEdits() {
            if (!this.cropDirty && !this.deferredDirty) return false;
            if (this.cropExceedsImage) return true;
            if (this.transformRotate || this.transformFlipH || this.transformFlipV) return true;
            if (!this.cropRect) return false;
            const { width, height } = this.naturalCropSize;
            if (!width || !height) return false;
            return this.cropRect.x > 1 || this.cropRect.y > 1
                || this.cropRect.width < width - 1 || this.cropRect.height < height - 1;
        },
        // Top → bottom: the live "Current Edit" (when there are edits), then the AI-edit
        // versions (newest first), then the pristine Original at the bottom. The base rows
        // show their UN-edited base; Current Edit shows the edited result.
        layersTopDown() {
            const bases = [...this.layers].reverse();
            if (!this.hasEdits) return bases;
            const active = this.activeLayer;
            if (!active) return bases;
            const currentEdit = {
                id: 'current',
                kind: 'current',
                label: this.$t('Current Edit'),
                active: true,
                file: active.file, // the baked, edited result → thumbnail
                cropBase: null,    // → layerThumb falls back to `file` (the edit)
            };
            return [currentEdit, ...bases.map(layer => ({ ...layer, active: false }))];
        },
        activeLayer() {
            return this.layers.find(layer => layer.active) || this.layers[0] || null;
        },
        // The pixels the cropper edits = the currently active layer (so crop stacks
        // on top of an AI-edit), falling back to the source.
        // The UNCROPPED pixels the crop tool edits (so re-cropping the active
        // version never double-crops). Falls back to the display/source.
        activeImageUrl() {
            // The canvas always renders through fileDisplayUrl/originalImageUrl (the
            // token-authenticated app proxy) and only falls back to raw CDN urls: a raw
            // `file.url` on DigitalOcean ignores the object's visibility, so a private
            // file came back AccessDenied → broken canvas image in production.
            return this.fileDisplayUrl(_.get(this.activeLayer, 'cropBase'))
                || this.fileDisplayUrl(_.get(this.activeLayer, 'file'))
                || originalImageUrl(this.localImage)
                || _.get(this.localImage, 'source.url')
                // `previewUrl` is the HOST's url for the ORIGINAL image — stale once the user
                // replaces the image (upload/library), so skip it then and render the new
                // working image from its own upload/file route below.
                || (this.replacementPending ? null : this.previewUrl)
                || null;
        },
        // The current displayed result (cropped) — shown on the canvas when not cropping.
        displayUrl() {
            return this.fileDisplayUrl(_.get(this.activeLayer, 'file'))
                || this.fileDisplayUrl(_.get(this.localImage, 'processedFile'))
                || originalImageUrl(this.localImage)
                || _.get(this.localImage, 'source.url')
                || null;
        },
        // Image shown in non-crop modes (view / AI / rotate / mirror) — the active
        // version's current pixels, falling back to the upload URL for fresh uploads.
        displayImageUrl() {
            return this.displayUrl
                || (this.replacementPending ? null : this.previewUrl)
                || originalImageUrl(this.localImage)
                || null;
        },
        // The transform state handed to EditorCanvas (it owns the geometry now).
        transformState() {
            return { rotate: this.transformRotate, flipH: this.transformFlipH, flipV: this.transformFlipV };
        },
        // True when a 90/270 rotation is active (the displayed aspect is swapped).
        transformRotated() {
            return this.transformRotate % 180 === 90;
        },
        // The source-frame aspect ratio handed to the canvas / used to reshape the source
        // crop rect. Derived from the DISPLAYED ratio the user picked: under a 90/270
        // rotation the source rect must be inverted so the visible crop keeps the lock.
        aspectRatio() {
            const displayed = Number(this.displayedAspect);
            if (!displayed || Number.isNaN(displayed)) return NaN;
            return this.transformRotated ? (1 / displayed) : displayed;
        },
        // Crop box dimensions as the user SEES them (source rect swapped for a 90/270
        // rotation). Used to pick the orientation a ratio preset should snap to.
        displayedCropSize() {
            if (!this.cropRect) return null;
            return this.transformRotated
                ? { width: this.cropRect.height, height: this.cropRect.width }
                : { width: this.cropRect.width, height: this.cropRect.height };
        },
        // Image dimensions as displayed (source dims swapped for a 90/270 rotation).
        displayedImageSize() {
            const { width, height } = this.naturalCropSize;
            return this.transformRotated ? { width: height, height: width } : { width, height };
        },
        // True once the crop frame extends past the image — there is revealed space to fill.
        cropExceedsImage() {
            const { width, height } = this.naturalCropSize;
            if (!this.cropRect || !width || !height) return false;
            return cropExceedsImage(this.cropRect, width, height);
        },
        // CSS colour for the canvas fill preview (null → checkerboard for transparent / AI).
        fillPreviewColor() {
            if (this.fillMode === 'transparent' || this.fillMode === 'ai') return null;
            return this.fillColorHex;
        },
        // Precise output-size inputs (DISPLAYED px). Reflect the crop's output dimensions;
        // typing a value resizes the crop about its centre — larger than the image expands
        // the canvas. A locked aspect derives the other dimension.
        outputCanvasWidth: {
            get() {
                if (!this.cropRect) return Math.round(this.displayedImageSize.width || 0);
                return Math.round(this.transformRotated ? this.cropRect.height : this.cropRect.width);
            },
            set(value) {
                const width = Math.max(1, Math.round(value || 0));
                const displayed = Number(this.displayedAspect);
                const height = (displayed && !Number.isNaN(displayed))
                    ? Math.round(width / displayed)
                    : this.outputCanvasHeight;
                this.setCropOutputSize(width, height);
            },
        },
        outputCanvasHeight: {
            get() {
                if (!this.cropRect) return Math.round(this.displayedImageSize.height || 0);
                return Math.round(this.transformRotated ? this.cropRect.width : this.cropRect.height);
            },
            set(value) {
                const height = Math.max(1, Math.round(value || 0));
                const displayed = Number(this.displayedAspect);
                const width = (displayed && !Number.isNaN(displayed))
                    ? Math.round(height * displayed)
                    : this.outputCanvasWidth;
                this.setCropOutputSize(width, height);
            },
        },
        // The natural pixel size of the crop SOURCE (the uncropped base the crop applies
        // to). The canvas reports the loaded image's TRUE intrinsic dims (measuredNatural),
        // which is authoritative — stored variant dims can be a folded crop's output (≠ the
        // uncropped pixels), which would skew the canvas. Fall back to the stored dims until
        // the image has loaded.
        naturalCropSize() {
            const measured = this.measuredNatural;
            if (measured && measured.url === this.activeImageUrl && measured.width && measured.height) {
                return { width: measured.width, height: measured.height };
            }
            const activeId = _.get(this.activeLayer, 'id');
            const fromSource = activeId === 'original' || !activeId;
            const width = (fromSource ? _.get(this.localImage, 'width') : _.get(this.activeLayer, 'width'))
                || _.get(this.localImage, 'source.width') || _.get(this.localImage, 'width') || 0;
            const height = (fromSource ? _.get(this.localImage, 'height') : _.get(this.activeLayer, 'height'))
                || _.get(this.localImage, 'source.height') || _.get(this.localImage, 'height') || 0;
            return { width, height };
        },
        // Cap the canvas height so a tall portrait doesn't push the rail to wrap.
        canvasMaxBoxHeight() {
            const clientHeight = (typeof document !== 'undefined' && document.documentElement)
                ? document.documentElement.clientHeight : 800;
            // The standalone (product) drawer is full-height with nothing below the editor,
            // so let the canvas use more of it — otherwise a short image leaves a big empty
            // gap. The INLINE (content/business-card) editor keeps a tighter cap so it does
            // not push the surrounding content form down the page.
            const factor = this.deferredCrop ? 0.7 : 0.82;
            const cap = this.deferredCrop ? 640 : 880;
            return Math.min(Math.round((clientHeight || 800) * factor), cap);
        },
        availableImages() {
            // Product mode: pick from the product's media. Single-image mode: just the
            // one image passed in (no picker shown).
            if (this.product) {
                return productImageOptions(this.product);
            }
            return this.image ? singleImageOption(this.image) : [];
        },
        // The product media entry for the image currently open in the editor — used to
        // read/show its role flags (main/list/detail) in the canvas overlay.
        activeProductMedia() {
            if (!this.showRoleToggles || this.sourceImageId == null) return null;
            return (_.get(this.product, 'media') || []).find(
                m => String(_.get(m, 'image.id')) === String(this.sourceImageId)
            ) || null;
        },
        selectedImage() {
            return this.availableImages.find(image => image.id === this.selectedImageId) || null;
        },
        // Per-image cost estimate for the AI content-aware fill (outpaint model).
        outpaintCostFormatted() {
            const price = _.get(this.outpaintModels, '[0].effectivePrice');
            return price ? moneyFormat(price, 'EUR') : null;
        },
        phaseLabel() {
            const key = this.generationPhase || 'starting';
            return this.$t('phase.' + key);
        },
        canGenerate() {
            return !this.generating
                && !this.phrasing
                && this.selectedImageId
                && this.selectedModelKey
                && (this.selectedOptionKey || this.selectedTemplateId)
                && this.phrasedPrompt.trim().length > 0;
        },
        // A template carrying reference images restricts the model picker to
        // multi-image (image_urls array) models — flux-kontext can't take them.
        // Non-product hosts only see 'general' templates (a product-tuned prompt
        // must not land on a CMS banner); product/article hosts see everything.
        templateContextArg() {
            return (this.subjectProductId || this.subjectArticleId) ? null : 'general';
        },
    },
    watch: {
        // In drawer mode the editor activates with `visible`; inline mode is always
        // active and activates on mount (see mounted()).
        active(value) {
            if (value) this.onOpen();
            else this.onClose();
        },
        selectedImageId(newId) {
            if (!newId) return;
            // Only spend Mistral suggestions when the user is actually in AI mode AND
            // looking at the Suggestions pane — clicking through versions while on
            // Templates must never trigger a paid suggestions call.
            if (this.mode === 'ai' && this.aiSource === 'suggestions') {
                this.loadSuggestions();
            } else {
                // The loaded suggestions (if any) belonged to the PREVIOUS image —
                // invalidate them so switching to the Suggestions pane later fetches
                // fresh ones instead of silently reusing suggestions for the wrong image
                // (setAiSource only reloads when the list is empty).
                this.suggestions = [];
            }
        },
        mode(value) {
            // Entering AI mode: templates first (no Mistral cost) — they are the
            // default source when the CMS has any; suggestions load lazily only
            // when that pane is actually shown.
            //
            // Deliberately NOT gated on `selectedImageId`. That is parseInt()'d from the
            // image id, so anything not yet persisted - a media-library pick or a fresh
            // upload, whose ids are client tokens like `new:file-library:123:abc` - makes
            // it NaN. The old guard then skipped initialisation entirely: no templates
            // (so no source toggle), no suggestions, and an empty panel with nothing to
            // pick and no way to continue. Templates are CMS-wide and never needed an
            // image; suggestions resolve their own subject via suggestionSubjectIds().
            if (value === 'ai') {
                this.enterAiMode();
            }
            // Entering crop mode: make sure there's a crop rectangle to show/edit.
            if (value === 'crop' && !this.cropRect) this.initCropRect();
        },
        // Keep the preview-thumbnail params (thumbCropParams) in step with the live
        // crop, but debounced: the canvas already shows the crop live (client-side
        // CSS), so the thumbnail only needs to catch up once the drag/zoom settles —
        // avoiding a backend preview render per tick.
        pendingCropParams: {
            handler(value) {
                if (!value) {
                    if (this.syncThumbCropParams) this.syncThumbCropParams.cancel();
                    this.thumbCropParams = null;
                    return;
                }
                // First params after open / version switch: reflect immediately so the
                // thumbnail isn't blank while the debounce settles.
                if (this.thumbCropParams === null) {
                    this.thumbCropParams = _.cloneDeep(value);
                    return;
                }
                if (this.syncThumbCropParams) this.syncThumbCropParams();
            },
            deep: true,
        },
    },
    methods: {
        // ===== Crop mode =====
        setAspectRatio(preset) {
            const reClick = this.activeRatioKey === preset.key;
            this.activeRatioKey = preset.key;
            if (preset.key === 'custom') {
                // Wait for the user to type "W:H" — applyCustomRatio() does the rest.
                this.applyCustomRatio();
                return;
            }
            // Free.
            if (preset.value === null) {
                this.displayedAspect = NaN;
                this.ratioLandscape = true;
                return;
            }
            // Original = the image's own displayed aspect (orientation fixed to the image).
            if (preset.value === 'original') {
                const { width, height } = this.displayedImageSize;
                this.ratioLandscape = width >= height;
                this.displayedAspect = (width && height) ? (width / height) : 1;
                this.reshapeCropToAspect();
                return;
            }
            // A fixed magnitude (stored ≥ 1). Square needs no orientation; otherwise pick
            // the orientation from the current crop box, and toggle it on re-click so one
            // button covers both landscape and portrait.
            const magnitude = preset.value >= 1 ? preset.value : 1 / preset.value;
            if (magnitude === 1) {
                this.ratioLandscape = true;
            } else if (reClick) {
                this.ratioLandscape = !this.ratioLandscape;
            } else {
                this.ratioLandscape = this.preferredLandscape();
            }
            this.displayedAspect = this.ratioLandscape ? magnitude : (1 / magnitude);
            this.reshapeCropToAspect();
        },
        // Label for a ratio button: the active fixed ratio reflects its current orientation
        // (portrait 16:9 shows as "9:16"), so one button visibly stands in for both.
        ratioLabel(preset) {
            if (preset.key === this.activeRatioKey && preset.value > 0 && preset.value !== 1 && !this.ratioLandscape) {
                const parts = preset.key.split(':');
                if (parts.length === 2) return `${parts[1]}:${parts[0]}`;
            }
            return preset.label;
        },
        // Decide whether a freshly-picked ratio should be landscape: follow the current
        // displayed crop box when it has a clear orientation, else the image's orientation.
        preferredLandscape() {
            const crop = this.displayedCropSize;
            if (crop && crop.width && crop.height) {
                const longer = Math.max(crop.width, crop.height);
                if (Math.abs(crop.width - crop.height) / longer > 0.02) {
                    return crop.width >= crop.height;
                }
            }
            const image = this.displayedImageSize;
            return image.width >= image.height;
        },
        // Parse a free-form "16:9" (or "1.78") ratio from the Custom input and apply it. The
        // typed ratio is in displayed space (what the user sees) and keeps its orientation.
        applyCustomRatio() {
            const raw = (this.customRatioInput || '').trim();
            let ratio = NaN;
            if (raw.indexOf(':') !== -1) {
                const [width, height] = raw.split(':').map(part => parseFloat(part));
                if (width > 0 && height > 0) ratio = width / height;
            } else if (raw) {
                const parsed = parseFloat(raw);
                if (parsed > 0) ratio = parsed;
            }
            this.displayedAspect = ratio;
            this.ratioLandscape = !Number.isNaN(ratio) && ratio >= 1;
            this.reshapeCropToAspect();
        },
        // Re-shape the current crop rect to the locked aspect, keeping its centre. Free ratio
        // (NaN/null) leaves the rect as-is.
        reshapeCropToAspect() {
            const ratio = Number(this.aspectRatio);
            if (!ratio || Number.isNaN(ratio) || !this.cropRect) return;
            const { width: natW, height: natH } = this.naturalCropSize;
            if (!natW || !natH) return;
            const centreX = this.cropRect.x + this.cropRect.width / 2;
            const centreY = this.cropRect.y + this.cropRect.height / 2;

            // Expanded crop (frame already past the image): preserve the frame's SIZE and
            // just reshape it to the ratio around its centre — keep it out of bounds, never
            // snap it back inside the image. Sized from the current larger dimension so a
            // 1:1 on a big frame stays big and square. EditorCanvas auto-zooms to fit it.
            if (this.cropExceedsImage) {
                const base = Math.max(this.cropRect.width, this.cropRect.height);
                const width = ratio >= 1 ? base : base * ratio;
                const height = ratio >= 1 ? base / ratio : base;
                this.cropRect = {
                    x: Math.round(centreX - width / 2),
                    y: Math.round(centreY - height / 2),
                    width: Math.round(width),
                    height: Math.round(height),
                };
                this.captureCrop();
                return;
            }

            // In-bounds crop: fit the largest rect of this ratio inside the current rect,
            // then clamp PROPORTIONALLY to the image (shrink keeping the ratio — never clamp
            // the two sides independently, which would break the aspect).
            let width = this.cropRect.width;
            let height = width / ratio;
            if (height > this.cropRect.height) {
                height = this.cropRect.height;
                width = height * ratio;
            }
            if (width > natW) { width = natW; height = width / ratio; }
            if (height > natH) { height = natH; width = height * ratio; }
            const x = this.clampValue(centreX - width / 2, 0, natW - width);
            const y = this.clampValue(centreY - height / 2, 0, natH - height);
            this.cropRect = { x: Math.round(x), y: Math.round(y), width: Math.round(width), height: Math.round(height) };
            this.captureCrop();
        },
        clampValue(value, min, max) {
            return Math.max(min, Math.min(max, value));
        },
        // Measure the editor row → pane content width (row − rail − gap), feeding the
        // contain math. Re-measured on open and window resize. NOTE: this number only
        // sizes the canvas BOX — it can never displace the rail. `.gm-editor__main` has
        // flex-basis 0, so the column is sized from the row's free space, not from its
        // content; a stale (too-wide) measurement is merely clipped by the pane's
        // padding instead of wrapping the rail underneath the canvas.
        measureCanvas() {
            this.$nextTick(() => {
                const root = this.$el;
                // Measure the canvas column (`.gm-editor__main`) directly. Its width is the
                // flex-determined free space (flex-basis 0), so on the desktop side-by-side
                // layout it equals row − rail(300) − gap(20) — identical to the old maths —
                // while on a stacked/narrow layout (e.g. mobile, where the rail wraps below)
                // it is the FULL row width. The old `row − 300 − 20` hardcoded a side-by-side
                // rail and collapsed the canvas to ~40px (distorted/overflowing) once stacked.
                const main = (root && root.querySelector ? root.querySelector('.gm-editor__main') : null)
                    || document.querySelector('.gm-editor-drawer .gm-editor__main');
                if (main && main.clientWidth > 0) {
                    this.canvasAvailableWidth = main.clientWidth;
                    return;
                }
                let row = root && root.querySelector ? root.querySelector('.gm-editor') : null;
                if (!row) row = document.querySelector('.gm-editor-drawer .gm-editor');
                if (!row) return;
                const width = row.clientWidth - 300 - 20; // rail basis + gap (fallback)
                if (width > 0) this.canvasAvailableWidth = width;
            });
        },
        // Live crop update from the canvas (drag / resize) — preview only, no persist.
        onCropUpdate(rect) {
            this.cropRect = rect;
        },
        // The canvas image finished loading. Capture its TRUE intrinsic size (authoritative
        // for the cropper — see naturalCropSize) and (re-)seed the crop rect with the now-
        // correct dims, so a saved crop / default box is derived against the real pixels.
        onCanvasReady(dims) {
            if (dims && dims.width && dims.height) {
                this.measuredNatural = { url: this.activeImageUrl, width: dims.width, height: dims.height };
            }
            // Re-derive the crop rect now that the TRUE pixel dims are known. Any rect
            // seeded before this point (version switch, open) was computed against the
            // layer's STORED dims — for a variant with a folded crop those are the crop
            // OUTPUT size, not the uncropped base — so it pointed at the wrong area and
            // (before hasEdits was gated on the dirty flags) spawned a phantom "Current
            // Edit" row. Skipped while the user has unsaved manual edits — never clobber
            // an in-progress crop.
            if (this.cropDirty || this.deferredDirty) return;
            if (this.mode === 'crop' || this.cropRect || this.fixedAspectRatio) this.initCropRect();
        },
        // Seed the crop rect (source px) from the active layer's saved params (restoring
        // the transform flags too), or a centred default when there's no saved crop.
        initCropRect() {
            const { width, height } = this.naturalCropSize;
            if (!width || !height) return;
            const params = this.pendingCropParams || _.get(this.activeLayer, 'params');
            if (params) {
                // Saved params were authored against the UNCROPPED base pixels. Until the
                // image has loaded, naturalCropSize falls back to the layer's STORED dims —
                // and for a variant with a folded crop those are the crop OUTPUT size, not
                // the base — so reconstructing against them mislocates the crop far out of
                // bounds. That premature seed then trips captureCrop (marking cropDirty),
                // which suppresses the onCanvasReady correction, so the wrong crop sticks
                // (visible only on a hard reload, where the image isn't cached). Defer the
                // restore until the true pixel dims are measured; onCanvasReady re-runs
                // initCropRect the moment they are.
                const measuredReady = this.measuredNatural
                    && this.measuredNatural.url === this.activeImageUrl
                    && this.measuredNatural.width && this.measuredNatural.height;
                if (!measuredReady) return;
                // Params mirror the imgix query string: rot (degrees) + flip (h|v|hv).
                // `rotate` is accepted as an alias for rot.
                this.transformRotate = Number(params.rot != null ? params.rot : params.rotate) || 0;
                const flip = String(params.flip || '');
                this.transformFlipH = flip.indexOf('h') !== -1;
                this.transformFlipV = flip.indexOf('v') !== -1;
                // Restore the fill mode/colour/prompt (only meaningful when the crop reaches
                // past the image, but harmless otherwise).
                if (params.fillColor || params.fill) {
                    const fillState = getFillStateFromParams(params);
                    this.fillMode = fillState.fillMode;
                    this.fillColorHex = '#' + fillState.fillColor;
                    this.fillPrompt = fillState.fillPrompt;
                }
                // Stored params are OUTPUT-absolute (imgix model); the canvas crop rect
                // lives in SOURCE coordinates, so map back before reconstructing the box.
                const sourceParams = toSourceFrame(params, this.transformRotate, this.transformFlipH, this.transformFlipV);
                const box = getImageCrop({ width, height, settings: { processing: sourceParams } }, null);
                if (box && box.width) {
                    this.cropRect = {
                        x: Math.round(box.x), y: Math.round(box.y),
                        width: Math.round(box.width), height: Math.round(box.height),
                    };
                    return;
                }
            }
            // No saved crop. With a LOCKED aspect ratio (e.g. business-card 1:1) default
            // to the largest CENTERED rect of that ratio — focal point centered, z=1 —
            // so the crop honours the lock before any manual drag (was: whole image,
            // which ignored the ratio). Free/unlocked → whole image (rotate/flip stay
            // non-destructive until the user drags in).
            const ratio = Number(this.aspectRatio);
            if (ratio && !Number.isNaN(ratio)) {
                let cropWidth = width;
                let cropHeight = Math.round(width / ratio);
                if (cropHeight > height) {
                    cropHeight = height;
                    cropWidth = Math.round(height * ratio);
                }
                this.cropRect = {
                    x: Math.round((width - cropWidth) / 2),
                    y: Math.round((height - cropHeight) / 2),
                    width: cropWidth,
                    height: cropHeight,
                };
                return;
            }
            this.cropRect = { x: 0, y: 0, width, height };
        },
        // Capture the current edit as a backend processing object. Two mutually-exclusive
        // shapes: a canvas expand (imgix fit=fillmax) when the output canvas exceeds the
        // image, otherwise a focal-point crop (fit=crop).
        captureCrop(markDirty = true) {
            const { width, height } = this.naturalCropSize;
            if (!width || !height || !this.cropRect) return;
            const sourceFocal = getProcessingFromCropData({ ...this.cropRect }, width, height);
            // OUTPUT-absolute geometry (imgix model): x/y/w/h describe the final, transformed
            // image. The processing object mirrors the query string 1:1 — x/y/z/w/h + rot +
            // flip (no abstracted rotate/flipH/flipV keys).
            const focal = toOutputFrame(sourceFocal, this.transformRotate, this.transformFlipH, this.transformFlipV);
            const processing = {
                fit: 'crop',
                crop: 'focalpoint',
                x: focal.x,
                y: focal.y,
                z: focal.z,
                w: focal.w,
                h: focal.h,
            };
            if (this.transformRotate) processing.rot = this.transformRotate;
            const flip = (this.transformFlipH ? 'h' : '') + (this.transformFlipV ? 'v' : '');
            if (flip) processing.flip = flip;
            // Canvas-expand: when the frame reaches past the image, attach the fill — a
            // solid/transparent colour, or fill:'gen' for AI outpaint. Plain in-bounds
            // crops carry no fill.
            if (this.cropExceedsImage) {
                Object.assign(processing, getFillParams(this.fillMode, this.fillColorHex, this.fillPrompt));
            }
            this.pendingCropParams = processing;
            // Solid/transparent fill (and ordinary crops) bake on Save (cropDirty). AI fill
            // is an async generate via its own button, so it must NOT arm the Save-crop path.
            const isAiFill = this.cropExceedsImage && this.fillMode === 'ai';
            if (markDirty && !isAiFill) this.persistCrop();
        },
        // Product → commit on drawer Save (cropDirty). Content / business card → emit the
        // ready-made processing object; the host stores it verbatim (one shared shape).
        persistCrop() {
            if (this.deferredCrop) {
                // Deferred mode emits the crop live (the host stores it on its content);
                // mark dirty so the drawer's Save (close-and-keep) is enabled too.
                // NOT while a replacement is still a draft: the host's image is then the OLD
                // one, so emitting here wrote the NEW image's geometry onto it (a 1920×1045
                // banner ended up carrying its replacement's 2480×3312 crop, which is what
                // made the untouched original render at the wrong ratio). saveAndClose folds
                // pendingCropParams onto the replacement instead, and @replaced carries it.
                if (this.pendingCropParams && !this.replacementPending) this.$emit('crop', this.pendingCropParams);
                this.deferredDirty = true;
            } else {
                this.cropDirty = true;
            }
        },
        // Crop drag/resize ended — persist the new region.
        onCropDirty() {
            this.captureCrop();
        },
        // Resize the crop to an exact output size (DISPLAYED px), keeping its centre. Larger
        // than the image → the canvas expands (out of bounds). Rotation-aware (the source
        // rect axes swap under a 90/270 rotation).
        setCropOutputSize(displayedWidth, displayedHeight) {
            if (!this.cropRect) this.initCropRect();
            if (!this.cropRect) return;
            const sourceWidth = Math.max(1, this.transformRotated ? displayedHeight : displayedWidth);
            const sourceHeight = Math.max(1, this.transformRotated ? displayedWidth : displayedHeight);
            const centerX = this.cropRect.x + this.cropRect.width / 2;
            const centerY = this.cropRect.y + this.cropRect.height / 2;
            this.cropRect = {
                x: Math.round(centerX - sourceWidth / 2),
                y: Math.round(centerY - sourceHeight / 2),
                width: sourceWidth,
                height: sourceHeight,
            };
            this.captureCrop();
        },
        // ----- Canvas-expand fill -----
        setFillMode(mode) {
            if (mode === 'auto') {
                this.autoFillFromEdge();
                this.fillMode = 'solid';
            } else {
                this.fillMode = mode;
            }
            if (this.cropExceedsImage) this.captureCrop();
        },
        onFillColorChange() {
            if (this.cropExceedsImage) this.captureCrop();
        },
        // Sample the image's outer edge to pick a fill colour that blends in. Uses the
        // token-authenticated app proxy URL (same-origin → the canvas isn't tainted); any
        // failure (CORS, load error) silently leaves the current colour.
        autoFillFromEdge() {
            const url = this.activeImageUrl;
            if (!url) return;
            const image = new Image();
            image.crossOrigin = 'anonymous';
            image.onload = () => {
                try {
                    const sampleCanvas = document.createElement('canvas');
                    sampleCanvas.width = image.naturalWidth;
                    sampleCanvas.height = image.naturalHeight;
                    const context = sampleCanvas.getContext('2d');
                    context.drawImage(image, 0, 0);
                    const width = sampleCanvas.width;
                    const height = sampleCanvas.height;
                    const points = [
                        [0, 0], [width - 1, 0], [0, height - 1], [width - 1, height - 1],
                        [Math.floor(width / 2), 0], [Math.floor(width / 2), height - 1],
                        [0, Math.floor(height / 2)], [width - 1, Math.floor(height / 2)],
                    ];
                    let red = 0;
                    let green = 0;
                    let blue = 0;
                    points.forEach(point => {
                        const pixel = context.getImageData(point[0], point[1], 1, 1).data;
                        red += pixel[0];
                        green += pixel[1];
                        blue += pixel[2];
                    });
                    const toHex = value => Math.round(value / points.length).toString(16).padStart(2, '0');
                    this.fillColorHex = '#' + toHex(red) + toHex(green) + toHex(blue);
                    if (this.cropExceedsImage) this.captureCrop();
                } catch (error) {
                    // Tainted/cross-origin canvas — keep the current colour.
                }
            };
            image.src = url;
        },
        // Reset the crop to the whole image (rotate / flip are left untouched). A full-image
        // crop contradicts a locked aspect ratio, so: if "Free" is available (no caller-
        // enforced ratio) we switch to Free; otherwise we keep the locked ratio and reset to
        // the largest centered crop of it.
        resetCrop() {
            const { width, height } = this.naturalCropSize;
            if (!width || !height) return;
            // Reset to the whole image — back inside the bounds, so any fill no longer applies.
            const ratioLocked = !Number.isNaN(Number(this.aspectRatio)) && Number(this.aspectRatio);
            this.cropRect = { x: 0, y: 0, width, height };
            if (ratioLocked && !this.fixedAspectRatio) {
                this.activeRatioKey = 'free';
                this.displayedAspect = NaN;
                this.ratioLandscape = true;
                this.captureCrop();
            } else if (ratioLocked) {
                this.reshapeCropToAspect(); // keep the enforced ratio; also captures
            } else {
                this.captureCrop();
            }
        },
        // Toolbar mode tools (Crop / AI edit) toggle: clicking the active one turns it off.
        toggleMode(target) {
            this.mode = this.mode === target ? null : target;
            // When a tool (Crop / AI edit) is activated, scroll its option panel into view.
            if (this.mode) this.scrollToToolPanelMobile();
        },
        // On a narrow/stacked layout (mobile drawer) the tool panel sits BELOW the canvas;
        // after picking a tool, bring its options into view. No-op on the desktop side-by-
        // side layout (>768px, panel already visible) and in the inline editor (CMS content).
        scrollToToolPanelMobile() {
            if (this.inline || typeof window === 'undefined' || window.innerWidth > 768) return;
            this.$nextTick(() => {
                const panel = document.querySelector('.gm-editor-drawer .gm-tool-panel');
                if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        },
        // Role flag (main/list/detail) of the image currently open — for the canvas overlay.
        productShow(scope) {
            return _.get(this.activeProductMedia, `settings.show.${scope}`) === true;
        },
        // ----- Transform actions (rotate / mirror) -----
        // The canvas transforms the whole stage; the crop rect (source coords) tracks the
        // motive on its own. We only flip the flag and persist (the focal is unchanged).
        rotate90() {
            this.transformRotate = (this.transformRotate + 90) % 360;
            this.afterTransform();
        },
        mirrorHorizontal() {
            this.transformFlipH = !this.transformFlipH;
            this.afterTransform();
        },
        mirrorVertical() {
            this.transformFlipV = !this.transformFlipV;
            this.afterTransform();
        },
        afterTransform() {
            // Transforms apply to the canvas in ANY mode (the stage always carries the
            // transform) — so DON'T force the crop tool back on. The crop rect lives in
            // SOURCE pixels and the stage's shared CSS transform rotates/flips it together
            // with the image, so the crop tracks the motive on its own — we must NOT reshape
            // it here (that would lose its position/size). Just re-capture so the output
            // params reflect the new orientation.
            if (!this.cropRect) this.initCropRect();
            this.captureCrop();
        },
        async applyCrop() {
            if (!this.localImage) return;
            // AI content-aware fill (fit=fillmax & fill=gen) is NOT a synchronous bake — it
            // runs through the async generative pipeline via its own "Generate fill" button,
            // never the Save-crop path, so there is nothing to apply here.
            if (this.cropExceedsImage && this.fillMode === 'ai') return;
            const base = this.activeLayer || {};
            const baseWidth = base.width || this.localImage.width;
            const baseHeight = base.height || this.localImage.height;
            // captureCrop() already folds the transform flags into pendingCropParams (in the
            // OUTPUT-absolute frame). If nothing was captured (no crop/transform touched),
            // fall back to a full-image crop, mapped to the output frame so w/h swap for a
            // 90/270 rotation just like a real crop would.
            let processing = this.pendingCropParams;
            if (!processing) {
                processing = toOutputFrame({
                    fit: 'crop', crop: 'focalpoint', x: 0.5, y: 0.5, z: 1,
                    w: Math.round(baseWidth), h: Math.round(baseHeight),
                }, this.transformRotate, this.transformFlipH, this.transformFlipV);
                if (this.transformRotate) processing.rot = this.transformRotate;
                const flip = (this.transformFlipH ? 'h' : '') + (this.transformFlipV ? 'v' : '');
                if (flip) processing.flip = flip;
            }

            // Fresh upload (no persisted Image): there is nothing to mutate yet —
            // ApplyImageCrop would get a NaN id. DEFER the crop onto the working image's
            // settings.processing and hand it to the host; the product/page save promotes
            // the upload carrying this crop (via the existing crop_settings path).
            if (this.isFreshUpload) {
                const settings = _.cloneDeep(_.get(this.localImage, 'settings') || {});
                settings.processing = processing;
                this.$set(this.localImage, 'settings', settings);
                this.cropDirty = false;
                this.$emit('updated', this.localImage);
                return;
            }

            this.applyingCrop = true;
            try {
                const updated = await api.applyImageCrop({
                    image_id: parseInt(this.localImage.id, 10),
                    processing,
                    base_id: base.id === 'original' ? null : base.id,
                    label: this.$t('Crop'),
                });
                this.applyResult(updated);
            } catch (error) {
                this.notifyError('Error', String(_.get(error, 'message') || error));
            } finally {
                this.applyingCrop = false;
            }
        },
        // ===== Layer stack =====
        // Switching a version is a LOCAL DRAFT — it updates the preview only. Nothing
        // is written to the server until the drawer's Save (product) / the host's save
        // (inline content). The canvas re-renders from the new active layer's URL/params.
        setActiveLayer(layer) {
            // The synthetic "Current Edit" row IS the active working state — clicking it
            // does nothing.
            if (layer.id === 'current' || layer.active) return;
            const layers = _.get(this.localImage, 'variants') || [];
            layers.forEach(other => this.$set(other, 'active', other.id === layer.id));
            // processing_query_string = the displayed file's token ('original' source → null).
            let token = _.get(layer, 'file.type', null);
            if (token === 'original') token = null;
            this.$set(this.localImage, 'processing_query_string', token);
            this.$set(this.localImage, 'processedFile', token ? layer.file : null);
            this.$set(this.localImage, 'activeVariant', layer);
            this.syncAiDisclosureToDisplayedFile(layer);
            this.activeDirty = true;
            // Switching base discards any pending crop (it belonged to the old version).
            this.cropDirty = false;
            this.transformRotate = 0;
            this.transformFlipH = false;
            this.transformFlipV = false;
            if (layer.id === 'original') {
                // Original = revert to the pristine image, no transform. With a LOCKED aspect
                // ratio the full frame usually ISN'T that ratio (a banner wider than 4:1 can't
                // be a full-frame 4:1 crop), so fit the largest centered ratio-correct rect
                // INSIDE the image — same default a fresh open uses (see initCropRect). Using
                // the whole frame here forced the crop past the edges (the "zoom out + offset"
                // bug). Free/unlocked reverts to the whole image.
                const { width, height } = this.naturalCropSize;
                const ratio = Number(this.aspectRatio);
                if (width && height && ratio && !Number.isNaN(ratio)) {
                    let cropWidth = width;
                    let cropHeight = Math.round(width / ratio);
                    if (cropHeight > height) {
                        cropHeight = height;
                        cropWidth = Math.round(height * ratio);
                    }
                    this.cropRect = {
                        x: Math.round((width - cropWidth) / 2),
                        y: Math.round((height - cropHeight) / 2),
                        width: cropWidth,
                        height: cropHeight,
                    };
                } else {
                    this.cropRect = (width && height) ? { x: 0, y: 0, width, height } : null;
                }
                this.pendingCropParams = null;
                // Compute the display crop only — a version switch is NOT a crop edit, so
                // it must not mark cropDirty. Otherwise Save would run applyCrop (which
                // crops the previously-active version) instead of committing the switch,
                // and "select Original + Save" would re-crop the old AI edit instead of
                // recovering the original.
                this.$nextTick(() => this.captureCrop(false));
            } else {
                // AI edit: load that version's own saved crop/transform.
                this.cropRect = null;
                this.pendingCropParams = null;
                this.$nextTick(() => this.initCropRect());
            }
            // The AI base just changed (different version = different pixels), so the
            // previous suggestions/prompt no longer apply. Only re-fetch (a paid Mistral
            // call) while the Suggestions pane is actually the one showing — switching
            // versions on the Templates pane must stay free, same as the selectedImageId
            // watcher below.
            if (this.mode === 'ai') {
                this.suggestions = [];
                this.selectedOptionKey = null;
                this.selectedOptionDescription = null;
                this.phrasedPrompt = '';
                if (this.aiSource === 'suggestions') this.$nextTick(() => this.loadSuggestions());
            }
            // Inline content/business-card: hand the draft to the host so its own save
            // persists it (the host owns the footer). Product mode commits on Save.
            if (this.deferredCrop) this.$emit('updated', this.localImage);
        },
        // Commit the drafted active version to the server (product drawer Save).
        async commitActiveVariant() {
            if (!this.activeDirty || !this.localImage) return null;
            const active = (_.get(this.localImage, 'variants') || []).find(layer => layer.active);
            const variantId = active && active.id !== 'original' ? active.id : 'original';
            const updated = await api.setActiveImageVariant(parseInt(this.localImage.id, 10), variantId);
            this.activeDirty = false;
            return updated;
        },
        // Product drawer Save: the single commit point. Applies a pending crop (on the
        // drafted active version) and/or commits the drafted active-version selection,
        // then closes. applyCrop already re-bakes the active base and emits `updated`.
        async saveAndClose() {
            this.saving = true;
            try {
                // Deferred (content / business-card): the crop/transform is handed to the
                // host via the live @crop event, which can MISS a transform (flip/rotate)
                // applied before the canvas finished measuring — captureCrop() bails with no
                // cropRect/dims and persistCrop never emits. Re-capture on save (the canvas
                // is always measured by now) so the final crop + flip + rotate is emitted.
                // Gated on cropTouched: OK is now reachable for a text-only edit too, and
                // re-capturing there would stamp a full-frame crop onto an image that never
                // had one.
                if (this.deferredCrop && !this.replacementPending && this.cropTouched) {
                    if (!this.cropRect) this.initCropRect();
                    this.captureCrop();
                }
                // A drafted image replacement (upload/library swap) commits to the host
                // ONLY now (on Save/OK) — never on pick — so Cancel leaves the original
                // media intact. Fold a pending crop onto the working image first.
                if (this.replacementPending) {
                    if (this.cropDirty) {
                        await this.applyCrop();
                        this.cropDirty = false;
                    }
                    // Deferred crop/transform on the replacement: fold it onto the working
                    // image so the host's @replaced merge carries it. The live @crop wrote
                    // the OLD content image, which @replaced then overwrites — so without
                    // this the crop is lost on a replace+crop.
                    if (this.deferredCrop && this.pendingCropParams) {
                        const settings = _.cloneDeep(_.get(this.localImage, 'settings') || {});
                        settings.processing = this.pendingCropParams;
                        this.$set(this.localImage, 'settings', settings);
                    }
                    this.$emit('replaced', this.localImage, this.replacementPreviousId);
                    this.replacementPending = false;
                    this.commitDraftedMetadata();
                    this.$emit('update:visible', false);
                    return;
                }
                // Fresh upload: nothing is persisted server-side here. A pending crop is
                // DEFERRED onto the working image (applyCrop emits `updated`, the host
                // merges it), the alt was already synced live. Just close — DON'T emit
                // `completed` (that would refetch the product and wipe the unsaved upload).
                if (this.isFreshUpload) {
                    if (this.cropDirty) {
                        await this.applyCrop();
                        this.cropDirty = false;
                    }
                    this.commitDraftedMetadata();
                    this.$emit('update:visible', false);
                    return;
                }
                // Commit a version switch FIRST. The backend crops the image's *active*
                // version (ApplyImageCrop reads the persisted active pointer), so it must
                // already be the version the user selected — otherwise a pending crop would
                // land on the previously-active layer, and "select Original + Save" would
                // never clear the pointer (it'd re-crop the old AI edit instead).
                const committedServerSide = this.activeDirty || this.cropDirty;
                if (this.activeDirty) {
                    const updated = await this.commitActiveVariant();
                    if (updated) this.applyResult(updated);
                }
                if (this.cropDirty) {
                    await this.applyCrop(); // commits the crop (and makes it the active layer)
                    this.cropDirty = false;
                }
                // `completed` makes the host refetch the product, which replaces its
                // media with the PERSISTED state. The AI disclosure fields have no
                // mutation of their own - they ride the host form's Save - so a refetch
                // with nothing else to commit throws the editor's decision away. Same
                // reasoning as the fresh-upload branch above: only refetch when
                // something was actually written server-side.
                if (committedServerSide) {
                    this.$emit('completed', { imageId: parseInt(this.localImage.id, 10) });
                }
                this.commitDraftedMetadata();
                this.$emit('update:visible', false);
                this.aiDisclosureDirty = false;
            this.aiDiscloseTouched = false;
            } catch (error) {
                this.notifyError('Error', String(_.get(error, 'message') || error));
            } finally {
                this.saving = false;
            }
        },
        deleteLayer(layer) {
            if (layer.kind === 'original') return;
            // Honour the "Don't keep asking" preference (localStorage), like the
            // file manager's delete.
            if (api.noDeleteVariantDialog() === 'true') {
                this.runDeleteLayer(layer);
                return;
            }
            this.deleteDialog = { visibility: true, loading: false, layer, remember: false };
        },
        confirmDeleteLayer() {
            if (this.deleteDialog.remember) {
                api.noDeleteVariantDialog(true);
            }
            this.runDeleteLayer(this.deleteDialog.layer);
        },
        async runDeleteLayer(layer) {
            if (!layer || !this.localImage) {
                this.closeDeleteDialog();
                return;
            }
            this.deleteDialog.loading = true;
            try {
                const updated = await api.deleteImageVariant(parseInt(this.localImage.id, 10), layer.id);
                this.applyResult(updated);
            } catch (error) {
                this.notifyError('Error', String(_.get(error, 'message') || error));
            } finally {
                this.closeDeleteDialog();
            }
        },
        closeDeleteDialog() {
            this.deleteDialog = { visibility: false, loading: false, layer: null, remember: false };
        },
        // A variant mutation returns the updated Image — refresh the local stack and
        // let the parent sync. The cropper updates via its reactive :src (no remount)
        // and the version list diffs by stable :key, so switching is flicker-free.
        applyResult(updatedImage) {
            if (updatedImage) this.localImage = updatedImage;
            // Pass the fresh image so single-image callers (content, business cards)
            // can update in place; product callers ignore it and refetch.
            this.$emit('updated', this.localImage);
        },
        // The version thumbnail shows the version's BASE image (Original → the actual
        // original; AI edit → the AI result) — NOT the crop/rotate/flip applied on top,
        // which would be misleading. cropBase is that uncropped base.
        layerThumb(layer) {
            // The "Current Edit" row must show the LIVE result (crop/rotate/flip applied
            // to the active base), not the un-edited base — otherwise it looks like the
            // original. Apply the captured processing to the base URL via the image
            // endpoint (same as the product tile / content ImageField).
            if (layer && layer.kind === 'current') {
                // Crop the thumbnail via the crop-capable APP endpoint (originalImageUrl →
                // /storage/{images|uploads}/{id}/…), NOT the CDN `source.url`: a static CDN
                // file ignores ?fit=crop, so appending the crop there would show the
                // original. The app endpoint applies it — identically for product uploads
                // AND persisted content/business-card images.
                const base = originalImageUrl(this.localImage)
                    || this.fileDisplayUrl(_.get(layer, 'cropBase'))
                    || this.fileDisplayUrl(_.get(layer, 'file'))
                    || this.activeImageUrl;
                // ephemeral=1 → the backend renders this transient preview in memory only
                // (no File row, no disk file), so tinkering with the crop never litters
                // the files table / disk with throwaway variants.
                // Use the DEBOUNCED params (thumbCropParams) so a crop/zoom drag doesn't
                // refetch the preview per tick. Reading thumbCropParams first (and only
                // falling back to the live params before the first debounce settles) keeps
                // pendingCropParams out of this render's reactive deps once warmed.
                const previewParams = this.thumbCropParams || this.pendingCropParams;
                if (base && previewParams) {
                    // Render the preview at thumbnail size, not the full crop-output size:
                    // the row image is ~48px, so a multi-megabyte full-res ephemeral render
                    // is pure waste (and a fpm-pool hazard under rapid edits).
                    const scaled = this.scaleParamsForThumb(previewParams);
                    let url = this.applyProcessingToUrl(base, scaled) + '&ephemeral=1';
                    // Crop on top of the SELECTED version's pixels (the AI edit shown on the
                    // canvas), not the original — same base the save bakes via base_file_id.
                    // Without this the thumbnail cropped the original and showed the wrong image.
                    if (this.activeBaseFileId) {
                        url += `&base_file_id=${this.activeBaseFileId}`;
                    }
                    return url;
                }
                return base;
            }
            return this.thumbnailFileUrl(
                this.fileDisplayUrl(_.get(layer, 'cropBase'))
                    || this.fileDisplayUrl(_.get(layer, 'file'))
            );
        },
        // Request a version thumbnail at display size. The /storage/.../files/{id}
        // route streams the FULL-resolution file when no size is given — the version
        // list (~48px rows) was downloading multi-megapixel originals. FileController
        // resizes File routes too when fit + w/h are present (fit=clip preserves the
        // whole image, just scaled down), so this makes each thumbnail tiny.
        thumbnailFileUrl(url) {
            if (!url || /[?&]fit=/.test(url)) return url;
            const sep = url.indexOf('?') !== -1 ? '&' : '?';
            return `${url}${sep}fit=clip&w=${THUMB_MAX_PX}&h=${THUMB_MAX_PX}`;
        },
        // Scale a crop processing object's output dimensions (w/h) down to thumbnail
        // size, preserving aspect ratio. x/y/z (focal point + zoom) are independent of
        // output size in the imgix model, so the crop is unchanged — only the rendered
        // pixel size shrinks, which is what makes the preview render cheap.
        scaleParamsForThumb(params) {
            if (!params) return params;
            const w = Number(params.w);
            const h = Number(params.h);
            if (!w || !h) return params;
            const longest = Math.max(w, h);
            if (longest <= THUMB_MAX_PX) return params;
            const scale = THUMB_MAX_PX / longest;
            return { ...params, w: Math.round(w * scale), h: Math.round(h * scale) };
        },
        // Display URL for a concrete File object (variant layer / processedFile): the
        // token-authenticated app proxy when the file carries id+name, else its raw url.
        // Raw CDN urls break for private objects (AccessDenied) — see proxiedFileUrl.
        fileDisplayUrl(file) {
            if (!file) return null;
            return proxiedFileUrl(file) || _.get(file, 'url') || null;
        },
        // Append a focal-crop (+ rot/flip) query to a base image URL so the endpoint
        // serves the edited pixels. Mirrors getFitStringFromProcessObject usage elsewhere.
        applyProcessingToUrl(url, processing) {
            if (!url || !processing) return url;
            let query = getFitStringFromProcessObject(processing);
            if (processing.rot) query += `&rot=${encodeURIComponent(processing.rot)}`;
            if (processing.flip) query += `&flip=${encodeURIComponent(processing.flip)}`;
            // Canvas-expand fill colour, so the preview shows the revealed area correctly.
            if (processing.fillColor) query += `&fillColor=${encodeURIComponent(processing.fillColor)}`;
            if (!query) return url;
            return url + (url.indexOf('?') !== -1 ? '&' : '?') + query;
        },
        formatBytes(bytes) {
            const value = Number(bytes);
            if (!value || Number.isNaN(value)) return null;
            if (value < 1024) return `${value} B`;
            if (value < 1024 * 1024) return `${(value / 1024).toFixed(0)} KB`;
            return `${(value / (1024 * 1024)).toFixed(1)} MB`;
        },
        kindLabel(layer) {
            return this.$t('kind.' + (layer.kind || 'crop'));
        },
        layerIcon(layer) {
            const map = { original: 'el-icon-fa-image', crop: 'el-icon-fa-crop', 'ai-edit': 'el-icon-fa-magic', current: 'el-icon-fa-sliders-h' };
            return map[layer.kind] || 'el-icon-fa-layer-group';
        },
        loadLocalImage() {
            // Product mode: find the image in the product's media. Single-image mode:
            // the image was passed in directly.
            if (this.product) {
                const media = (this.product.media || []).find(item => _.get(item, 'image.id') == this.sourceImageId);
                this.localImage = media ? _.cloneDeep(media.image) : null;
                return;
            }
            this.localImage = this.image ? _.cloneDeep(this.image) : null;
        },
        selectOption(suggestion) {
            this.selectedOptionKey = suggestion.key;
            this.selectedOptionDescription = suggestion.description;
            // A suggestion / custom prompt replaces any template selection (and
            // lifts its model restriction).
            this.selectedTemplateId = null;
            if (suggestion.key === 'custom') {
                // Custom: the user writes the final prompt themselves.
                this.phrasedPrompt = '';
                return;
            }
            this.phraseSelected();
        },
        // ===== Prompt templates =====
        async enterAiMode() {
            await this.loadTemplates();
            this.aiSource = this.templatesTotal > 0 ? 'templates' : 'suggestions';
            if (this.aiSource === 'suggestions' && !this.suggestions.length) {
                this.loadSuggestions();
            }
        },
        setAiSource(source) {
            this.aiSource = source;
            if (source === 'suggestions' && !this.suggestions.length) {
                this.loadSuggestions();
            }
        },
        async loadTemplates() {
            if (!this.cmsId) return;
            this.loadingTemplates = true;
            try {
                const page = await api.fetchPromptTemplates(this.cmsId, 5, 0, this.templateContextArg);
                this.templates = page.items || [];
                this.templatesTotal = page.total || 0;
            } catch (error) {
                this.templates = [];
                this.templatesTotal = 0;
            } finally {
                this.loadingTemplates = false;
            }
        },
        async loadMoreTemplates() {
            if (this.loadingMoreTemplates) return;
            this.loadingMoreTemplates = true;
            try {
                const page = await api.fetchPromptTemplates(this.cmsId, 5, this.templates.length, this.templateContextArg);
                this.templates = this.templates.concat(page.items || []);
                this.templatesTotal = page.total || this.templatesTotal;
            } catch (error) {
                // Keep the existing list on failure.
            } finally {
                this.loadingMoreTemplates = false;
            }
        },
        // Apply a template: its STORED prompt goes into the editable textarea
        // verbatim — no Mistral call, no orchestration cost. Templates with
        // references restrict the model picker to multi-image models and
        // auto-switch when the current model can't take them.
        selectTemplate(template) {
            this.selectedTemplateId = template.id;
            this.selectedOptionKey = null;
            this.selectedOptionDescription = null;
            this.phrasedPrompt = template.prompt || '';

            // A template is a curated config — apply its saved model too, not just the
            // prompt. Constrain the pool to multi-image models when it carries references.
            const hasReferences = (template.references || []).length > 0;
            const pool = hasReferences ? this.models.filter(model => model.supportsReferences) : this.models;
            const templateModel = template.model_key && pool.find(model => model.key === template.model_key);
            if (templateModel) {
                this.selectedModelKey = templateModel.key;
            } else if (hasReferences && !pool.some(model => model.key === this.selectedModelKey)) {
                // No usable saved model, but references need a multi-image one and the
                // current pick can't take them → switch to the first capable model.
                this.selectedModelKey = pool.length ? pool[0].key : this.selectedModelKey;
            }

            // ...and its cost levers, for the same reason: the template is a curated
            // config. Null means the template doesn't decide, so the shop default
            // applies — which AiEditControls fills in from the model's *Default fields.
            this.outputQuality = template.quality || null;
            this.outputResolutionCap = template.resolution_cap || null;
        },
        async phraseSelected() {
            this.phrasing = true;
            try {
                this.phrasedPrompt = await api.phrasePrompt({
                    product_id: this.subjectProductId,
                    article_id: this.subjectArticleId,
                    cms_id: this.cmsId,
                    capability: 'image-edit',
                    option_key: this.selectedOptionKey,
                    option_description: this.selectedOptionDescription,
                });
            } catch (error) {
                this.phrasedPrompt = this.selectedOptionDescription || '';
            } finally {
                this.phrasing = false;
                this.resizePrompt();
                this.refreshOrchestrationCost();
            }
        },
        // el-input autosize doesn't recompute on programmatic v-model changes, so
        // trigger it manually after the prompt is populated (avoids a scrollbar).
        resizePrompt() {
            this.$nextTick(() => {
                const input = this.$refs.promptInput;
                if (input && typeof input.resizeTextarea === 'function') {
                    input.resizeTextarea();
                }
            });
        },
        rephrase() {
            if (this.selectedOptionKey && this.selectedOptionKey !== 'custom') {
                this.phraseSelected();
            }
        },
        // Actual AI-prep cost for THIS edit only: snapshot a baseline on open and
        // show only the delta consumed in this session (suggest/phrase calls).
        async refreshOrchestrationCost() {
            if (!this.cmsId) return;
            try {
                const current = await api.incurredCost(this.cmsId, 'image-edit') || 0;
                this.orchestrationCost = Math.max(0, current - this.orchestrationBaseline);
            } catch (error) {
                // Keep the previous value on failure.
            }
        },
        async onOpen() {
            this.resetState();
            // Caller-enforced fixed ratio (e.g. business-card 1:1): lock it, presets hidden.
            if (this.fixedAspectRatio) {
                this.displayedAspect = this.fixedAspectRatio;
                this.ratioLandscape = this.fixedAspectRatio >= 1;
                this.activeRatioKey = null;
            }
            // The drawer is always opened for a specific image: an explicit
            // sourceImageId (product tile) or the single image passed in.
            this.selectedImageId = this.sourceImageId || (this.image ? parseInt(_.get(this.image, 'id'), 10) : null);
            this.loadLocalImage();
            // Pre-select the crop tool when the image already carries a saved crop, so
            // the user lands on it. A persisted edit stores it as the active variant's
            // `params`; a DEFERRED crop (fresh upload, or a legacy lazy crop on content /
            // business cards) lives in `settings.processing`. Seed that into
            // pendingCropParams so initCropRect restores the crop + rotate/flip — without
            // it, reopening a fresh upload reset every transform.
            // Deferred crops (content / business-card) live in settings.processing — the
            // host's storage — NOT in a variant layer. ALWAYS restore them from there; a
            // layer's `params` reflect a baked product crop and would otherwise shadow the
            // live deferred crop (reopening showed the stale/old crop instead of the latest).
            const layerParams = this.deferredCrop ? null : _.get(this.activeLayer, 'params');
            const deferredProcessing = layerParams ? null : _.get(this.localImage, 'settings.processing');
            if (layerParams || deferredProcessing) {
                if (deferredProcessing) this.pendingCropParams = _.cloneDeep(deferredProcessing);
                this.mode = 'crop';
                this.initCropRect();
            } else {
                // For a LOCKED aspect ratio (e.g. business-card 1:1) seed the default
                // centered crop rect WITHOUT entering crop mode, so the canvas shows the
                // passive "what's actually used" overlay on open (dim outside, no editing
                // chrome). onCanvasReady re-seeds once the real pixel dims are known.
                this.mode = this.startInCrop ? 'crop' : null;
                if (this.fixedAspectRatio || this.startInCrop) this.initCropRect();
            }
            // Seed the panel from the version that is actually active, the same way a
            // version switch does - otherwise the drawer opens showing the image-level
            // values while the canvas already shows a specific version. Not a change the
            // editor made, so it must not enable Save.
            if (this.activeLayer) {
                this.syncAiDisclosureToDisplayedFile(this.activeLayer, { markDirty: false });
            }
            this.measureCanvas();
            // If a generation is already running for this subject (started earlier, in
            // this or another tab), resume its progress view so closing/reopening the
            // drawer doesn't "lose" it.
            this.resumeActiveTask();

            // AI tab data is only fetched when the AI feature is enabled (and the
            // suggestions themselves are loaded lazily on first entering AI mode).
            if (this.aiEnabled) {
                this.loadingModels = true;
                try {
                    this.models = await api.fetchModels('image-edit', this.cmsId);
                    const settings = await api.fetchSettings(this.cmsId);
                    this.selectedModelKey = _.get(settings, 'default_image_edit_model_key') || _.get(this.models, '[0].key', null);
                } finally {
                    this.loadingModels = false;
                }
                // The outpaint model (content-aware fill) — its price drives the cost estimate
                // shown on the "Generate fill" button. Best-effort; the estimate hides if absent.
                try {
                    this.outpaintModels = await api.fetchModels('image-outpaint', this.cmsId);
                } catch (error) {
                    this.outpaintModels = [];
                }
                // Snapshot the period orchestration cost so this session's delta starts at 0.
                try {
                    this.orchestrationBaseline = await api.incurredCost(this.cmsId, 'image-edit') || 0;
                } catch (error) {
                    this.orchestrationBaseline = 0;
                }
                this.orchestrationCost = 0;
            }
        },
        onClose() {
            this.unsubscribe();
            this.stopTaskWatchdog();
        },
        // Inline mode only: re-check for an in-flight task whenever the editor becomes
        // visible again (its host drawer was closed and reopened without unmounting it).
        // IntersectionObserver covers every host mechanism — el-drawer v-show, scroll,
        // keep-alive — without per-host wiring.
        setupInlineVisibilityResume() {
            if (typeof IntersectionObserver === 'undefined') return;
            // Mounted visible → onOpen() already ran; only act on later hidden→visible flips.
            let wasVisible = true;
            this.visibilityObserver = new IntersectionObserver((entries) => {
                const visible = entries.some(entry => entry.isIntersecting);
                if (visible && !wasVisible && !this.generating) {
                    this.resumeActiveTask();
                }
                wasVisible = visible;
            }, { threshold: 0 });
            this.visibilityObserver.observe(this.$el);
        },
        // Resolve the backend subject the SAME way generate() does — by source
        // kind, not the synthetic `new:` client id. A library pick logs against
        // the File, a genuine upload against the uploads-table id, a persisted
        // image against the image id. (For product edits the StatusLog logs
        // against the Product, so product_id resolves them regardless — but
        // CMS-content / business-card edits have no product and MUST match by the
        // right file/upload/image id, else the progress overlay never resumes.)
        activeTaskSubject() {
            const fileId = this.librarySourceFileId;
            const uploadId = (this.isFreshUpload && !fileId) ? this.freshUploadId : null;
            const imageId = (this.isFreshUpload || !this.selectedImageId)
                ? null
                : (parseInt(this.selectedImageId, 10) || null);
            return { fileId, uploadId, imageId };
        },
        // Resume an in-flight AI edit (late joiner): if the backend still has a running
        // task for this subject, show its progress and subscribe for live updates.
        async resumeActiveTask() {
            try {
                const { fileId, uploadId, imageId } = this.activeTaskSubject();
                const task = await api.activeTask(this.productId, imageId, uploadId, fileId);
                if (task && (task.status === 'pending' || task.status === 'processing')) {
                    this.generating = true;
                    this.generationProgress = task.progress || 0;
                    this.generationPhase = 'generating';
                    this.subscribeToProgress();
                    this.startTaskWatchdog();
                }
            } catch (error) {
                // No resume on failure — the user can still start a fresh edit.
            }
        },
        // Safety net while a generation runs: websockets can drop (production proxies,
        // sleeping laptops) and a SIGKILL'd worker never broadcasts a terminal event —
        // either way the overlay froze forever (reported as "stuck at 78%"). Poll the
        // task's DB state and finalize from there when the broadcasts went missing.
        startTaskWatchdog() {
            this.stopTaskWatchdog();
            this.taskWatchdog = setInterval(() => this.checkActiveTask(), 15000);
        },
        stopTaskWatchdog() {
            if (this.taskWatchdog) {
                clearInterval(this.taskWatchdog);
                this.taskWatchdog = null;
            }
        },
        async checkActiveTask() {
            if (!this.generating) {
                this.stopTaskWatchdog();
                return;
            }
            try {
                const { fileId, uploadId, imageId } = this.activeTaskSubject();
                const task = await api.activeTask(this.productId, imageId, uploadId, fileId);
                if (!task) return;
                if (task.status === 'pending' || task.status === 'processing') {
                    // Still running — mirror the DB progress in case the progress
                    // broadcasts are the part that's failing.
                    this.generationProgress = Math.max(this.generationProgress || 0, task.progress || 0);
                    return;
                }
                // Terminal state reached but no broadcast arrived — finalize from the DB.
                // The synthetic payloads carry OUR subject ids so they pass the
                // payloadMatchesSubject guard (upload/library flows have no numeric
                // image id of their own).
                this.stopTaskWatchdog();
                if (task.status === 'completed') {
                    let data = {};
                    try {
                        data = JSON.parse(task.data || '{}') || {};
                    } catch (parseError) {
                        data = {};
                    }
                    const resultImageId = parseInt(data.promoted_image_id, 10)
                        || parseInt(data.source_image_id, 10)
                        || (parseInt(this.selectedImageId, 10) || null);
                    this.onTaskCompleted({ imageId: resultImageId, uploadId, fileId });
                } else {
                    this.onTaskFailed({
                        imageId,
                        uploadId,
                        fileId,
                        error: task.body || task.heading || this.$t('Generation failed'),
                    });
                }
            } catch (error) {
                // Transient polling failure — keep waiting; the next tick retries.
            }
        },
        async loadSuggestions() {
            // Persisted images suggest by image id; fresh uploads by their uploads-table
            // id; library picks by the File id behind the pick.
            const subject = this.suggestionSubjectIds;
            if (!subject) {
                // Nothing the backend can look at yet. Returning silently left the panel
                // completely empty - no chips, no skeleton - so there was no way to start
                // an edit at all. The editor can always write their own prompt.
                if (!this.suggestions.length) {
                    this.suggestions = [{ key: 'custom', label: this.$t('Custom prompt'), description: '' }];
                }

                return;
            }
            this.loadingSuggestions = true;
            const { imageIds, uploadIds, fileIds } = subject;
            try {
                this.suggestions = await api.suggestOptions(this.subjectProductId, 'image-edit', imageIds, this.$i18n.locale, undefined, uploadIds, this.cmsId, fileIds, this.subjectArticleId);
            } catch (error) {
                this.suggestions = [{ key: 'custom', label: this.$t('Custom prompt'), description: '' }];
            } finally {
                this.loadingSuggestions = false;
                this.refreshOrchestrationCost();
            }
        },
        // Fetch additional, distinct suggestions and append them (custom stays last).
        async loadMoreSuggestions() {
            const subject = this.suggestionSubjectIds;
            if (!subject || this.loadingMore) return;

            const existingLabels = this.suggestions
                .filter(suggestion => suggestion.key !== 'custom')
                .map(suggestion => suggestion.label);

            this.loadingMore = true;
            const { imageIds, uploadIds, fileIds } = subject;
            try {
                const more = await api.suggestOptions(
                    this.subjectProductId,
                    'image-edit',
                    imageIds,
                    this.$i18n.locale,
                    existingLabels,
                    uploadIds,
                    this.cmsId,
                    fileIds,
                    this.subjectArticleId,
                );
                const normalize = suggestion => (suggestion.label || '').trim().toLowerCase();
                const seenKeys = new Set(this.suggestions.map(suggestion => suggestion.key));
                const seenLabels = new Set(this.suggestions.map(normalize));
                const fresh = more.filter(suggestion =>
                    suggestion.key !== 'custom'
                    && !seenKeys.has(suggestion.key)
                    && !seenLabels.has(normalize(suggestion))
                );
                const custom = this.suggestions.filter(suggestion => suggestion.key === 'custom');
                const others = this.suggestions.filter(suggestion => suggestion.key !== 'custom');
                this.suggestions = [...others, ...fresh, ...custom];
            } catch (error) {
                // Keep the existing suggestions on failure.
            } finally {
                this.loadingMore = false;
                this.refreshOrchestrationCost();
            }
        },
        async generate() {
            if (!this.canGenerate) return;
            // Reset progress BEFORE showing the overlay — a repeat generation must start at
            // 0%, not the previous run's leftover 100% (which lingers until the first
            // .task:progress event arrives).
            this.generationProgress = 0;
            this.generationPhase = 'starting';
            this.generating = true;
            try {
                await api.generateImageEdit({
                    product_id: this.subjectProductId,
                    article_id: this.subjectArticleId,
                    // No product/article → bill the active CMS; the backend also falls back
                    // to the image's own CMS.
                    cms_id: this.productId ? null : this.cmsId,
                    // A persisted image edits its DB source; a fresh upload edits the
                    // uploads-table file directly; a library pick edits the existing File
                    // (the backend promotes upload/file → Image, no Image exists yet).
                    // parseInt: selectedImageId can be a STRING (the GraphQL id) and the
                    // mutation arg is Int — an unparsed string fails coercion ("Int cannot
                    // represent non-integer value").
                    source_image_id: this.isFreshUpload ? null : (parseInt(this.selectedImageId, 10) || null),
                    source_upload_id: (this.isFreshUpload && !this.librarySourceFileId) ? this.freshUploadId : null,
                    source_file_id: this.librarySourceFileId,
                    // A library File carries no stored dimensions, so the backend can't
                    // honour "keep source size" (it would default to square). Pass the
                    // dimensions the editor already measured so the promoted Image keeps them.
                    source_width: parseInt(_.get(this.localImage, 'width'), 10) || null,
                    source_height: parseInt(_.get(this.localImage, 'height'), 10) || null,
                    // Edit the pixels of the VERSION the user has selected in the stack
                    // (a draft selection that isn't saved yet) — not whatever the DB still
                    // records as active. Null for the Original (backend uses the source).
                    base_file_id: this.activeBaseFileId,
                    // When the editor was opened on an EXISTING product image and the user
                    // replaced it (library/upload) before generating, the promoted result
                    // must take over that image's media slot — not spawn a new tile. Pass
                    // the replaced image's id so the job replaces it in place.
                    replace_image_id: (this.replacementPending && /^\d+$/.test(String(this.replacementPreviousId)))
                        ? parseInt(this.replacementPreviousId, 10)
                        : null,
                    model_key: this.selectedModelKey,
                    option_key: this.selectedOptionKey,
                    option_description: this.selectedOptionDescription,
                    final_prompt: this.phrasedPrompt,
                    // Applied prompt template — the backend sends its reference
                    // images alongside the source (image 1 = the edited image).
                    template_id: this.selectedTemplateId,
                    // Fresh uploads are promoted to a real Image server-side; carry the crop
                    // the user selected so the promoted Original layer keeps it.
                    crop_settings: (this.isFreshUpload && this.pendingCropParams)
                        ? JSON.stringify({ processing: this.pendingCropParams })
                        : null,
                    // Output dimensions: keep the source size by default, or force a
                    // ratio + orientation. Orientation is irrelevant for "source"/"1:1".
                    aspect_ratio: this.outputAspect,
                    orientation: this.outputOrientation,
                    quality: this.outputQuality,
                    resolution_cap: this.outputResolutionCap,
                });
                this.subscribeToProgress();
                this.startTaskWatchdog();
            } catch (error) {
                this.generating = false;
                this.notifyError('Error', String(_.get(error, 'message') || error));
            }
        },
        // AI content-aware fill (imgix fill=gen): outpaint the image onto the expanded
        // canvas via the async generative pipeline (its own progress, a new version) —
        // mirrors generate() but sends the fill geometry (the out-of-bounds crop) instead
        // of a prompt/edit.
        async generateOutpaint() {
            if (!this.localImage || !this.cropExceedsImage) return;
            this.captureCrop(false); // refresh pendingCropParams (the focal crop + fill:'gen')
            const fill = this.pendingCropParams;
            if (!fill) return;
            this.generationProgress = 0;
            this.generationPhase = 'starting';
            this.generating = true;
            try {
                await api.generateImageEdit({
                    product_id: this.subjectProductId,
                    article_id: this.subjectArticleId,
                    cms_id: this.productId ? null : this.cmsId,
                    source_image_id: this.isFreshUpload ? null : (parseInt(this.selectedImageId, 10) || null),
                    source_upload_id: (this.isFreshUpload && !this.librarySourceFileId) ? this.freshUploadId : null,
                    source_file_id: this.librarySourceFileId,
                    source_width: parseInt(_.get(this.localImage, 'width'), 10) || null,
                    source_height: parseInt(_.get(this.localImage, 'height'), 10) || null,
                    base_file_id: this.activeBaseFileId,
                    // model_key omitted → the backend resolves the outpaint model.
                    fill_settings: JSON.stringify(fill),
                });
                this.subscribeToProgress();
                this.startTaskWatchdog();
            } catch (error) {
                this.generating = false;
                this.notifyError('Error', String(_.get(error, 'message') || error));
            }
        },
        // ===== Replace via upload / media library =====
        openLibrary() {
            this.libraryDialogVisible = true;
        },
        onLibrarySelect(payload) {
            this.libraryDialogVisible = false;
            // Single-select: payload is the library image (id `new:file-library:…`,
            // with a nested `source`). Adopt it as the working image.
            if (payload) this.adoptReplacementImage(_.cloneDeep(payload));
        },
        // Mirrors the product/business-card upload reference: the computed uploadHeaders
        // reads the store token, so refresh it here when the current JWT is expired.
        async updateUploadHeaders() {
            await ensureFreshToken();
        },
        async validateReplaceUpload(file) {
            await this.updateUploadHeaders();
            const maxBytes = 50 * 1024 * 1024;
            if (file.size > maxBytes) {
                this.notifyError('Error', this.$t('The file is too large.'));
                return false;
            }
            return true;
        },
        onUploadSuccess(response) {
            // Build a working image from the fresh upload (source.upload = pixels live
            // in the uploads table). Mirrors the host upload handlers' shape.
            this.adoptReplacementImage({
                id: uniqid('new:'),
                width: _.get(response, 'dimensions.width'),
                height: _.get(response, 'dimensions.height'),
                source: {
                    id: response.id,
                    name: response.name,
                    preferred_name: response.preferred_name,
                    hash: response.hash,
                    mime: response.mime,
                    type: 'original',
                    upload: true,
                },
            });
        },
        onUploadError(error) {
            this.notifyError('Error', String(_.get(error, 'message') || error));
        },
        // Swap the working image (upload or library pick) and reset all edit drafts so
        // the new image starts clean; tell the host to swap its reference (@replaced).
        adoptReplacementImage(image) {
            // DRAFT only: swap the editor's working image so the canvas previews it, but
            // DON'T emit `replaced` yet — that would mutate the host's media immediately
            // (broken tile + no undo on Cancel). The swap commits to the host on Save/OK.
            // Remember the FIRST original id so Cancel/Save still target the right slot
            // even after several replacements in one session.
            if (!this.replacementPending) {
                this.replacementPreviousId = _.get(this.localImage, 'id');
            }
            this.replacementPending = true;
            this.localImage = image;
            this.selectedImageId = image.id;
            // A replacement brings its own Art. 50 record: an AI image picked out of the
            // library is disclosed because that FILE is disclosed, and a plain photo
            // clears whatever the previous image had. A fresh upload has no record at
            // all, so this correctly resets to "not AI" until the editor says otherwise.
            //
            // Read it off the version actually adopted. Picking a VERSION from the
            // library (pickVariant) builds the image from the parent file and attaches
            // the chosen variant separately, so the record is on that variant's file -
            // looking at the source would report the untouched original instead.
            this.aiDiscloseTouched = false;
            this.syncAiDisclosureToDisplayedFile(
                _.get(image, 'activeVariant') || { kind: 'original', cropBase: _.get(image, 'source') },
                { markDirty: false }
            );
            this.cropRect = null;
            this.pendingCropParams = null;
            this.transformRotate = 0;
            this.transformFlipH = false;
            this.transformFlipV = false;
            this.measuredNatural = null;
            this.mode = null;
            // Preserve a caller-enforced aspect lock (e.g. business-card 1:1) across the
            // replace — mirror onOpen — so the new image gets the same passive default
            // crop. Without this the ratio dropped to Free and the locked square was lost.
            if (this.fixedAspectRatio) {
                this.activeRatioKey = null;
                this.displayedAspect = this.fixedAspectRatio;
                this.ratioLandscape = this.fixedAspectRatio >= 1;
            } else {
                this.activeRatioKey = 'free';
                this.displayedAspect = NaN;
            }
            this.cropDirty = false;
            this.activeDirty = false;
            this.suggestions = [];
            this.selectedOptionKey = null;
            this.selectedOptionDescription = null;
            this.selectedTemplateId = null;
            this.phrasedPrompt = '';
            this.$nextTick(() => this.measureCanvas());
            // Inline hosts (CMS content / business cards) have NO editor Save button —
            // they commit on the HOST's save — so saveAndClose() (the only other place
            // that emits `replaced`) never runs and the swap would be lost. Hand the
            // replacement to the host NOW as a draft: its content array is itself unsaved
            // until the section save, and Cancel discards the whole section, so there's no
            // "mutates persisted media" risk that the product drawer defers around.
            // Without this, replacing an inline image and saving reverts to the original
            // (and an in-flight AI edit can never be resumed — it targets the dropped file).
            if (this.inline) {
                this.$emit('replaced', this.localImage, this.replacementPreviousId);
            }
        },
        // Alt text edited/generated in the drawer. Update the working image and tell
        // the host (product form) to sync its media image so the product Save persists
        // it — there is no standalone alt mutation; alt rides the product payload.
        onAltInput(alt) {
            if (this.localImage) this.$set(this.localImage, 'alt', alt);
            this.propagateWhenInline();
        },
        // Art. 50(4) disclosure decision. Rides the host payload exactly like alt does
        // — there is no standalone disclosure mutation, and the editor confirming it
        // is the point, so it saves with everything else they were doing.
        onAiDiscloseInput(disclose) {
            if (this.localImage) this.$set(this.localImage, 'ai_disclosure', disclose === true);
            this.aiDiscloseTouched = true;
            // Without this the commit button stays disabled: it only watches the crop
            // and version flags, so a disclosure change alone looked like "nothing
            // happened" and could not be saved.
            this.aiDisclosureDirty = true;
            this.propagateWhenInline();
        },
        onAiLabelDisplayInput(mode) {
            this.aiDisclosureDirty = true;
            // null means "inherit the shop setting"; keep it null rather than ''
            // so the backend fallback stays a real inherit.
            const value = mode || null;
            if (this.localImage) this.$set(this.localImage, 'ai_label_display', value);
            this.propagateWhenInline();
        },
        // A version switch changes WHICH file the shopper sees, and Art. 50 attaches to
        // exactly that file: an AI edit is a variant stacked on an untouched photo, so
        // selecting the Original means nothing synthetic is on screen and nothing is
        // owed, while selecting an AI version means it is.
        syncAiDisclosureToDisplayedFile(layer, { markDirty = true } = {}) {
            if (!this.localImage) return;

            // Which file this row actually PUTS ON SCREEN. The Original row is the trap:
            // its `file` is the currently active variant (the backend uses that field for
            // the result thumbnail), so reading it would report the AI edit's record for
            // the pristine photo. Its `cropBase` is the real original; for every other
            // row the two agree.
            const isOriginal = _.get(layer, 'kind') === 'original' || _.get(layer, 'id') === 'original';
            const file = isOriginal
                ? (_.get(layer, 'cropBase') || _.get(this.localImage, 'source'))
                : (_.get(layer, 'file') || _.get(layer, 'cropBase'));

            // Everything here is stored PER FILE, so switching version swaps the whole
            // record: the decision, the rationale that explains it, the display mode and
            // the alt text that describes what is actually shown.
            // Read, never inferred. The version's own `kind` says it was made by the AI
            // editor, but that is OUR generation record, not an Art. 50 declaration —
            // deriving a term from it made this panel show a labelling the database did
            // not have, while the storefront (which reads the database) showed none.
            const provenance = _.get(file, 'ai_source_type') || null;
            const assessment = _.get(file, 'ai_assessment') || null;
            const labelDisplay = _.get(file, 'ai_label_display') || null;
            const alt = _.get(file, 'description') || '';

            this.$set(this.localImage, 'ai_source_type', provenance);
            this.$set(this.localImage, 'ai_assessment', assessment);
            this.$set(this.localImage, 'ai_label_display', labelDisplay);
            this.$set(this.localImage, 'alt', alt);

            // The switch shows what is STORED for this file and nothing else. Whether an
            // asset carries a visible Art. 50(4) label is the shop's decision and their
            // responsibility; a drawer that switches itself on for an undeclared file
            // both misreports the shop's own data and quietly claims that decision for us.
            //
            // Skipped once the editor has flipped it by hand, so switching version cannot
            // undo a declaration they just made.
            if (!this.aiDiscloseTouched) {
                const disclose = _.get(file, 'ai_disclosure') === true;
                this.$set(this.localImage, 'ai_disclosure', disclose);
            }

            this.propagateWhenInline();

            if (markDirty) this.aiDisclosureDirty = true;
        },
        // Whether the asset was fully generated or is a photo we edited. Backend-set
        // for our own generations; for anything uploaded the editor is the only source
        // of truth, and the two produce different wording on the storefront.
        // Drawer state is DETACHED: the alt text and the Art. 50 panel edit this
        // drawer's own copy and the host learns about them only on OK, like the crop,
        // the version switch and a pending replacement already did. Close discards.
        commitDraftedMetadata() {
            const imageId = _.get(this.localImage, 'id');
            if (!imageId) return;

            this.$emit('update-image-alt', imageId, _.get(this.localImage, 'alt') || '');
            this.$emit('update-image-ai-disclosure', imageId, _.get(this.localImage, 'ai_disclosure') === true);
            this.$emit('update-image-ai-source-type', imageId, _.get(this.localImage, 'ai_source_type') || null);
            this.$emit('update-image-ai-label-display', imageId, _.get(this.localImage, 'ai_label_display') || null);
        },
        // INLINE hosts (CMS content, business cards) have no OK of their own - the
        // editor is embedded in their form and committed by THEIR save - so there is no
        // later moment to hand a draft over. Those keep propagating as the editor types.
        propagateWhenInline() {
            if (this.inline) this.commitDraftedMetadata();
        },
        onAiSourceTypeInput(sourceType) {
            this.aiDisclosureDirty = true;
            if (this.localImage) this.$set(this.localImage, 'ai_source_type', sourceType || null);
            this.propagateWhenInline();
        },
        // System-wide notification convention: bottom-left, dark.
        notifyError(title, message) {
            this.$notify.error({
                title: this.$t(title),
                message,
                iconClass: 'fas el-icon-fa-times',
                position: 'bottom-left',
                customClass: 'dark',
                duration: 8000,
            });
        },
        // Product edits broadcast on the product channel; single-image edits on the
        // per-image channel (matches the backend's broadcastOn()).
        // The candidate broadcast channels for the active subject. Usually one, but a
        // PERSISTED image needs two: the per-image channel (direct edits) AND its
        // source-file channel — because a library/upload edit that was promoted into this
        // Image keeps broadcasting on `generative-media.file.{sourceFileId}` for its whole
        // life (see TaskProgress::broadcastOn). On reopen the subject is the promoted
        // Image, so without the file channel the resumed progress + completion never
        // arrive (frozen bar, image never replaced).
        channelNames() {
            // Library pick (existing File, no Image yet): product context broadcasts on
            // the product channel; product-less on the per-file channel. Checked first
            // because a library pick is also a "fresh upload" (new: token) but has no
            // upload id — the generic fresh-upload branch would build upload.null.
            if (this.librarySourceFileId) {
                return this.productId
                    ? [`generative-media.${this.subjectType}.${this.productId}`]
                    : [`generative-media.file.${this.librarySourceFileId}`];
            }
            // Fresh uploads broadcast on a per-upload channel (no Image exists yet) —
            // even in product context, since there's no product Image yet.
            if (this.isFreshUpload) return [`generative-media.upload.${this.freshUploadId}`];
            if (this.productId) return [`generative-media.${this.subjectType}.${this.productId}`];
            const names = [`generative-media.image.${this.selectedImageId}`];
            const sourceFileId = parseInt(_.get(this.localImage, 'source.id'), 10);
            if (sourceFileId) names.push(`generative-media.file.${sourceFileId}`);
            return names;
        },
        subscribeToProgress() {
            if (!Echo.client) Echo.initialize();
            // Leave any previously-subscribed channels first (re-subscribe on reopen).
            this.unsubscribe();
            this.channels = this.channelNames();
            this.channels.forEach((name) => {
                const channel = Echo.client.private(name);
                channel.listen('.task:progress', (payload) => this.onTaskProgress(payload));
                channel.listen('.task:completed', (payload) => this.onTaskCompleted(payload));
                channel.listen('.task:failed', (payload) => this.onTaskFailed(payload));
            });
        },
        // The product channel is SHARED by every generation of the product, so events
        // arriving here may belong to a DIFFERENT image's task (e.g. drawer opened for
        // image B while image A generates). Only react when the payload identifies OUR
        // subject. Payloads carrying NO subject ids (early phases of an upload/library
        // promotion broadcast before any Image exists) are accepted only while THIS
        // drawer is generating — they can't be attributed, and dropping our own events
        // would freeze our overlay.
        payloadMatchesSubject(payload) {
            if (_.get(payload, 'type') === 'video') return false;
            const payloadImageId = parseInt(_.get(payload, 'imageId'), 10) || null;
            const payloadUploadId = parseInt(_.get(payload, 'uploadId'), 10) || null;
            const payloadFileId = parseInt(_.get(payload, 'fileId'), 10) || null;
            if (!payloadImageId && !payloadUploadId && !payloadFileId) {
                return this.generating;
            }
            const ownImageId = parseInt(this.selectedImageId, 10) || null;
            if (payloadImageId && ownImageId && payloadImageId === ownImageId) return true;
            if (payloadUploadId && this.freshUploadId && payloadUploadId === this.freshUploadId) return true;
            if (payloadFileId && this.librarySourceFileId && payloadFileId === this.librarySourceFileId) return true;
            // A library/upload edit promoted INTO this persisted image keeps its
            // per-file identity for the whole job — match our image's source File.
            const ownSourceFileId = parseInt(_.get(this.localImage, 'source.id'), 10) || null;
            if (payloadFileId && ownSourceFileId && payloadFileId === ownSourceFileId) return true;
            return false;
        },
        onTaskProgress(payload) {
            if (!this.payloadMatchesSubject(payload)) return;
            this.generationProgress = payload.progress;
            this.generationPhase = payload.phase;
        },
        async onTaskCompleted(payload) {
            if (!this.payloadMatchesSubject(payload)) return;
            this.stopTaskWatchdog();
            this.generationProgress = 100;
            this.generating = false;
            // The result always lives on a persisted Image (payload.imageId): the SAME
            // image for a direct edit, or the promoted/replaced image for an
            // upload/library edit. Adopt it so the drawer shows the AI result (the new
            // active variant) and STAYS OPEN — closing was jarring and threw away the
            // result the user just made.
            const resultImageId = parseInt(_.get(payload, 'imageId'), 10);
            if (resultImageId) {
                const previousId = _.get(this.localImage, 'id');
                try {
                    const image = await api.fetchEditableImage(resultImageId);
                    if (image) {
                        this.localImage = _.cloneDeep(image);
                        this.selectedImageId = resultImageId;
                        // The EDIT is committed server-side now — drop the local crop draft
                        // so the canvas re-derives from the persisted active layer. A pending
                        // REPLACEMENT (upload / library pick) stays pending: the job promoted
                        // it into a persisted Image, but the host still points at the image
                        // the user replaced — that swap only commits on Save/OK (saveAndClose).
                        // Clearing it here dropped the swap entirely: the commit button fell
                        // back to disabled (nothing looked dirty) and the host kept the old
                        // image, so a later crop landed on the WRONG image.
                        this.pendingCropParams = null;
                        this.cropRect = null;
                        this.measuredNatural = null;
                        this.mode = null;
                        this.$emit('updated', this.localImage, previousId);
                    }
                } catch (error) {
                    this.notifyError('Error', String(_.get(error, 'message') || error));
                }
            }
            this.$emit('completed', payload);
        },
        onTaskFailed(payload) {
            if (!this.payloadMatchesSubject(payload)) return;
            this.stopTaskWatchdog();
            this.generating = false;
            this.notifyError('Generation failed', payload.error);
        },
        unsubscribe() {
            if (Echo.client && this.channels) {
                this.channels.forEach((name) => Echo.client.leave(name));
            }
            this.channels = [];
        },
        resetState() {
            this.replacementPending = false;
            this.replacementPreviousId = null;
            this.suggestions = [];
            this.templates = [];
            this.templatesTotal = 0;
            this.aiSource = 'suggestions';
            this.selectedTemplateId = null;
            this.selectedImageId = null;
            this.selectedOptionKey = null;
            this.selectedOptionDescription = null;
            this.outputAspect = 'source';
            this.outputOrientation = 'landscape';
            this.outputQuality = null;
            this.outputResolutionCap = null;
            this.phrasedPrompt = '';
            this.phrasing = false;
            this.orchestrationCost = 0;
            this.orchestrationBaseline = 0;
            this.generationProgress = null;
            this.generationPhase = null;
            this.generating = false;
            this.mode = null;
            this.displayedAspect = NaN;
            this.ratioLandscape = true;
            this.activeRatioKey = 'free';
            this.applyingCrop = false;
            this.saving = false;
            this.aiDisclosureDirty = false;
            this.aiDiscloseTouched = false;
            this.activeDirty = false;
            this.cropDirty = false;
            this.deferredDirty = false;
            this.transformRotate = 0;
            this.transformFlipH = false;
            this.transformFlipV = false;
            this.pendingCropParams = null;
            this.cropRect = null;
            this.localImage = null;
        },
    },
    mounted() {
        // Inline mode starts active (no visible→true transition to watch).
        if (this.inline) {
            this.onOpen();
            // Inline hosts (CMS content) keep the editor MOUNTED while the surrounding
            // drawer is just hidden (el-drawer without destroy-on-close) — so onOpen()
            // never re-runs and an in-flight generation's progress overlay wouldn't come
            // back on reopen. Watch real visibility and re-check for an active task on each
            // hidden→visible transition. Drawer mode doesn't need this (its `active`
            // watcher already re-runs onOpen).
            this.setupInlineVisibilityResume();
        }
        this.measureCanvas();
        this.onResize = () => this.measureCanvas();
        window.addEventListener('resize', this.onResize);
        // Debounced refresh of the preview-thumbnail params: a crop/zoom drag updates
        // pendingCropParams many times; the thumbnail only refetches once it settles.
        this.syncThumbCropParams = _.debounce(() => {
            this.thumbCropParams = this.pendingCropParams ? _.cloneDeep(this.pendingCropParams) : null;
        }, 300);
    },
    beforeDestroy() {
        this.unsubscribe();
        this.stopTaskWatchdog();
        if (this.syncThumbCropParams) this.syncThumbCropParams.cancel();
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.visibilityObserver) {
            this.visibilityObserver.disconnect();
            this.visibilityObserver = null;
        }
    },
};
</script>

<style lang="stylus" scoped>
// Accent comes from the context-aware CSS vars defined in globals.sass:
// --gm-accent (CMS = blue, shop = purple) + --gm-accent-hover / --gm-accent-bg tints.

.gm-form
    padding-top 20px
    padding-bottom 20px

.gm-image-editor
    // The editor can be embedded inside an el-form-item, whose .el-form-item__content
    // forces line-height: 36px upstream — that leaks into our text/controls. Reset it.
    line-height 1.5

    &--inline
        border 1px solid #ebeef5
        border-radius 8px
        padding 12px 16px

.gm-inline-actions
    display flex
    justify-content flex-end
    gap 8px
    padding 12px 0 4px
    margin-top 12px
    border-top 1px solid #f2f3f5

// ===== Two-pane editor: canvas (left) + tool rail (right) =====
.gm-editor
    display flex
    flex-wrap wrap
    gap 20px
    align-items flex-start

    // Left column: toolbar + canvas, stacked. flex-basis 0 (NOT auto) is load-bearing:
    // the canvas box width comes from a one-shot JS measurement, and with a
    // content-driven basis any stale (too-wide) measurement made this column overflow
    // the wrapping row and pushed the rail underneath the canvas. Basis 0 sizes the
    // column from the row's FREE SPACE instead, so the rail can never be displaced;
    // an over-measured canvas is absorbed by the pane padding until re-measured.
    &__main
        flex 1 1 0
        min-width 0
        display flex
        flex-direction column
        gap 12px
        align-items flex-start
        // The rail (AI controls, cost, versions) routinely runs longer than the canvas
        // column — without this the canvas scrolls out of view while scrolling down to
        // reach rail content. Sticks against `.drawer-body`, the nearest scrolling
        // ancestor (see the `>>> .drawer-body` padding rule below).
        position sticky
        top 0

    // The canvas pane: full-width grey area; the contained image is centred within it
    // (justify/align-items center), so a portrait/rotated image sits in a consistent
    // pane with no lopsided gap. The 16px padding gives the cropper handles room; only
    // the PANE clips (handles stay in the padding).
    &__canvas
        position relative
        flex 0 0 auto
        width 100%
        max-width 100%
        display flex
        align-items center
        justify-content center
        background #f5f7fa
        border-radius 8px
        padding 16px
        box-sizing border-box
        overflow hidden

    &__preview
        width 100%
        height 56vh
        max-height 460px
        display flex
        align-items center
        justify-content center
        background #f5f7fa
        border 1px solid #ebeef5
        border-radius 8px
        img
            max-width 100%
            max-height 100%
            object-fit contain
            border-radius 4px

    &__empty
        color #c0c4cc
        font-size 40px
        padding 60px

    &__rail
        flex 0 0 300px
        min-width 260px
        display flex
        flex-direction column
        gap 18px

// Produkt-Bildrollen-Overlay (Hauptbild / Listenbild / Produktseite) über dem Canvas.
.gm-roles
    position absolute
    left 50%
    bottom 10px
    transform translateX(-50%)
    display flex
    gap 6px
    padding 4px 6px
    background rgba(0, 0, 0, .55)
    border-radius 8px
    z-index 5

.gm-role
    border none
    background none
    color #d6d6e0
    cursor pointer
    padding 6px 9px
    display inline-flex
    align-items center
    justify-content center
    border-radius 6px
    transition background .15s ease, color .15s ease

    i
        font-size 14px

    &.active
        color #fff
        background var(--gm-accent)

// Toolbar above the canvas: mode tools (Crop / AI edit) + transform actions
// (rotate / mirror), grouped with a divider. Full width of the canvas column.
.gm-toolbar
    display flex
    align-items center
    gap 6px
    width 100%
    padding 5px
    background #f4f5f7
    border-radius 8px
    box-sizing border-box

    &__group
        display inline-flex
        align-items center
        gap 4px

    &__sep
        width 1px
        height 22px
        background #dcdfe6
        margin 0 4px

.gm-tool
    display inline-flex
    align-items center
    gap 6px
    border none
    background transparent
    color #606266
    font-size 13px
    font-weight 600
    padding 7px 14px
    border-radius 6px
    cursor pointer
    transition all .15s ease

    &:hover
        color var(--gm-accent)

    &.active
        background #fff
        color var(--gm-accent)
        box-shadow 0 1px 3px rgba(0, 0, 0, .12)

    // Icon-only action buttons (rotate / mirror): square, no label.
    &--icon
        padding 7px
        width 34px
        justify-content center
        font-size 15px

        &:disabled
            color #c0c4cc
            cursor not-allowed

// Templates | Suggestions source toggle inside the AI panel — same look as the
// canvas toolbar's tool buttons, scaled to the rail.
.gm-source-toggle
    display flex
    gap 6px
    padding 5px
    background #f4f5f7
    border-radius 8px

    .gm-tool
        flex 1 1 0
        justify-content center

.gm-tool-panel
    display flex
    flex-direction column
    gap 14px

    // The panel already spaces its children with `gap`; a label that is a direct
    // child must not ALSO add margin-bottom (it would stack with the gap).
    > .gm-label
        margin-bottom 0

// Versions list (Original + AI edits)
.gm-versions-section
    padding-top 4px
    border-top 1px solid #f2f3f5

.gm-versions
    display flex
    flex-direction column
    gap 6px

.gm-version
    position relative
    display flex
    align-items center
    gap 10px
    padding 6px
    border 1px solid #e4e7ed
    border-radius 8px
    cursor pointer
    transition border-color .15s ease, background .15s ease

    &:hover
        border-color var(--gm-accent-hover)

    &.active
        border-color var(--gm-accent)
        background var(--gm-accent-bg)

    &__thumb
        flex 0 0 40px
        width 40px
        height 40px
        border-radius 6px
        overflow hidden
        background #f4f5f7
        img
            width 100%
            height 100%
            object-fit cover
            display block

    &__meta
        flex 1 1 auto
        min-width 0
        display flex
        align-items center
        gap 5px
        font-size 12px
        color #303133
        overflow hidden
        white-space nowrap
        text-overflow ellipsis

    &__icon
        font-size 11px
        color var(--gm-accent)

    &__label
        color #909399
        // A flex CHILD does not inherit the parent's ellipsis: without its own
        // min-width the box grows to fit the text, and an AI edit's label is the whole
        // prompt. That pushed the editor ~50px past the drawer and produced a
        // horizontal scrollbar across the whole panel.
        min-width 0
        overflow hidden
        white-space nowrap
        text-overflow ellipsis

    &__cost
        color #909399
        flex 0 0 auto
        white-space nowrap

    &__active
        color var(--gm-accent)
        font-size 12px

    &__delete
        flex 0 0 auto
        border none
        background transparent
        color #c0c4cc
        cursor pointer
        padding 4px
        font-size 12px
        &:hover
            color #f56c6c

// Wide canvas modal (product context)
// Product-media editor drawer (rtl). Footer pinned at the bottom of the drawer body.
.gm-editor-drawer
    >>> .drawer-body
        padding 16px 24px

    >>> .drawer-footer
        display flex
        justify-content flex-end
        gap 8px

// Mode switch (Crop | AI edit)
.gm-modes
    display flex
    gap 18px
    margin-bottom 22px
    border-bottom 1px solid #ebeef5

.gm-mode
    display inline-flex
    align-items center
    gap 6px
    border none
    background none
    padding 8px 2px
    margin-bottom -1px
    cursor pointer
    font-size 14px
    font-weight 600
    color #909399
    border-bottom 2px solid transparent
    transition color .15s ease, border-color .15s ease

    i
        font-size 13px

    &:hover
        color var(--gm-accent)

    &.active
        color var(--gm-accent)
        border-bottom-color var(--gm-accent)

// Aspect-ratio lock buttons
// Alt-text panel sits underneath the editor (matching the CMS content layout).
.gm-below-editor
    margin-top 16px
    // The alt-text and AI-labelling panels stack here; without a gap they render
    // flush against each other and read as one broken card.
    display flex
    flex-direction column
    gap 12px

.gm-ratios
    display flex
    flex-wrap wrap
    gap 6px

.gm-orientation
    display flex
    gap 6px
    margin-top 6px

    .gm-ratio
        display inline-flex
        align-items center
        gap 5px

.gm-ratio
    border 1px solid #dcdfe6
    background #fff
    color #606266
    border-radius 6px
    padding 5px 10px
    font-size 12px
    line-height 1
    cursor pointer
    transition all .15s ease

    &:hover
        border-color var(--gm-accent)
        color var(--gm-accent)

    &.active
        background var(--gm-accent)
        border-color var(--gm-accent)
        color #fff

// Output-size inputs (W × H)
.gm-size-inputs
    display flex
    align-items center
    gap 6px

    .el-input-number
        width 104px

.gm-size-x
    color #909399
    font-size 12px

// Canvas-expand fill: mode buttons + colour picker
.gm-fill-modes
    display flex
    flex-wrap wrap
    gap 6px
    margin-bottom 8px

    .gm-ratio
        display inline-flex
        align-items center
        gap 5px

.gm-fill-color
    display block

.gm-fill-prompt
    margin-top 8px

// Layer stack
.gm-stack
    display flex
    flex-direction column
    gap 8px

.gm-layer
    position relative
    display flex
    align-items center
    gap 12px
    padding 8px
    border 1px solid #e4e7ed
    border-radius 8px
    cursor pointer
    background #fff
    transition border-color .15s ease, background .15s ease

    &:hover
        border-color var(--gm-accent-hover)

    &.active
        border-color var(--gm-accent)
        background #f7f4ff

    &__thumb
        flex-shrink 0
        width 44px
        height 44px
        border-radius 6px
        overflow hidden
        background #f0f0f2

        img
            width 100%
            height 100%
            object-fit cover
            display block

    &__meta
        flex 1
        min-width 0

    &__kind
        display flex
        align-items center
        gap 6px
        font-size 13px
        font-weight 600
        color #303133

        i
            font-size 11px
            color var(--gm-accent)

    &__label
        font-size 12px
        color #909399
        white-space nowrap
        overflow hidden
        text-overflow ellipsis

    &__active
        color var(--gm-accent)
        font-size 13px

    &__delete
        border none
        background none
        color #c0c4cc
        cursor pointer
        padding 6px
        font-size 13px
        transition color .15s ease

        &:hover
            color #f56c6c

// .gm-section
//     & + &
//         margin-top 26px

// Image meta strip (dimensions + file info) above the tool options.
.gm-meta
    display flex
    flex-direction column
    gap 5px
    padding-bottom 14px
    margin-bottom 14px
    border-bottom 1px solid #ebeef5

    &__row
        display flex
        align-items baseline
        justify-content space-between
        gap 12px
        font-size 12px
        line-height 1.4

    &__key
        color #909399

    &__val
        color #303133
        font-weight 500
        font-variant-numeric tabular-nums

        // A filename is arbitrarily long and must not push the dimension column
        // out of the rail; the full name stays available on hover.
        &--name
            min-width 0
            overflow hidden
            text-overflow ellipsis
            white-space nowrap

.gm-label
    display block
    font-size 13px
    font-weight 600
    color #303133
    margin-bottom 10px

.gm-hint
    font-size 12px
    line-height 1.4
    color #909399
    margin-top -4px
    margin-bottom 10px

    &--below
        margin-top 6px
        margin-bottom 0

// Secondary action — mirrors .gm-rephrase: a quiet icon+text link, not a button.
.gm-reset-crop
    display inline-flex
    align-items center
    gap 5px
    margin-top 10px
    border none
    background none
    padding 0
    cursor pointer
    font-size 12px
    color #909399
    transition color .15s ease

    &:hover
        color var(--gm-accent)
        text-decoration underline

    .el-icon-refresh-left
        font-size 13px

// Prompt review
.gm-prompt-head
    display flex
    align-items center
    justify-content space-between

.gm-rephrase
    display inline-flex
    align-items center
    gap 5px
    border none
    background none
    padding 0
    cursor pointer
    font-size 12px
    color var(--gm-accent)

    &:hover
        text-decoration underline

    &:disabled
        color #c0c4cc
        cursor not-allowed
        text-decoration none

// Source image preview (the image this drawer was opened for)
.gm-source
    width 96px
    height 96px
    border-radius 8px
    overflow hidden
    border 2px solid #409EFF

    img
        width 100%
        height 100%
        object-fit cover
        display block

// Image picker
.gm-grid
    display flex
    flex-wrap wrap
    gap 10px

.gm-tile
    position relative
    width 76px
    height 76px
    border-radius 8px
    overflow hidden
    cursor pointer
    border 2px solid #e4e7ed
    transition border-color .15s ease, transform .15s ease

    img
        width 100%
        height 100%
        object-fit cover
        display block

    &:hover
        border-color var(--gm-accent-hover)
        transform translateY(-1px)

    &.selected
        border-color var(--gm-accent)

    &__check
        position absolute
        top 4px
        left 4px
        width 20px
        height 20px
        border-radius 10px
        background var(--gm-accent)
        color #fff
        font-size 13px
        font-weight 700
        line-height 20px
        text-align center
        box-shadow 0 1px 3px rgba(0, 0, 0, .3)

// Suggestion chips
.gm-chips
    display flex
    flex-wrap wrap
    gap 8px

// Shimmering skeleton chips while suggestions load
.gm-chip-skeleton
    display inline-block
    width 130px // base width (used for the "load more" skeletons appended after chips)
    height 31px
    border-radius 18px
    background linear-gradient(90deg, #f0f0f2 25%, #e6e6ea 37%, #f0f0f2 63%)
    background-size 400% 100%
    animation gm-shimmer 1.4s ease infinite

    &:nth-child(1)
        width 150px
    &:nth-child(2)
        width 110px
    &:nth-child(3)
        width 175px
    &:nth-child(4)
        width 125px
    &:nth-child(5)
        width 95px

@keyframes gm-shimmer
    0%
        background-position 100% 50%
    100%
        background-position 0 50%

.gm-chip
    display inline-flex
    align-items center
    gap 6px
    padding 7px 14px
    border-radius 18px
    border 1px solid #dcdfe6
    background #fff
    color #606266
    font-size 13px
    line-height 1
    cursor pointer
    transition all .15s ease

    &:hover
        border-color var(--gm-accent)
        color var(--gm-accent)

    &.active
        background var(--gm-accent)
        border-color var(--gm-accent)
        color #fff

    &.is-custom
        border-style dashed

        &.active
            border-style solid

    &.gm-more
        border-style dashed
        color var(--gm-accent)

        &:disabled
            color #c0c4cc
            border-color #dcdfe6
            cursor not-allowed

.gm-custom
    margin-top 12px

// Cost summary (pinned above footer)
.gm-cost
    padding 12px 20px
    background #f7f4ff
    border-top 1px solid #ece6ff

    &__row
        display flex
        align-items baseline
        justify-content space-between

        &--muted
            margin-top 6px

    &__line
        display flex
        align-items center
        gap 6px

        .el-icon-info
            color #b8a9e8
            cursor help

    &__label
        font-size 13px
        color #303133

    &__est
        font-size 11px
        color #909399

    &__amount
        font-size 20px
        font-weight 700
        color var(--gm-accent)

    &__amount--muted
        font-size 14px
        font-weight 600
        color #8a8a99

    // Single-line estimate (AI fill): stack "estimate" UNDER the label and centre the
    // amount against it, so the band reads as a balanced label/price pair.
    &--stack
        .gm-cost__row
            align-items center
        .gm-cost__line
            flex-direction column
            align-items flex-start
            gap 0

// AI Generate — full-width primary action living with the AI controls (under the
// cost), themed with the context accent (shop = purple, CMS = blue).
.gm-generate.el-button
    width 100%
    margin-top 12px
    background var(--gm-accent)
    border-color var(--gm-accent)
    color #fff

    &:hover,
    &:focus
        background var(--gm-accent-hover)
        border-color var(--gm-accent-hover)
        color #fff

    &.is-disabled,
    &.is-disabled:hover,
    &.is-disabled:focus
        background var(--gm-accent)
        border-color var(--gm-accent)
        color #fff
        opacity 0.45

// Generating state
.gm-generating
    display flex
    flex-direction column
    align-items center
    justify-content center
    text-align center
    padding 48px 32px
    height 100%

    &__phase
        margin-top 20px
        font-size 15px
        font-weight 600
        color #303133

    &__hint
        margin-top 10px
        max-width 320px
        font-size 12px
        line-height 1.5
        color #909399
</style>
